import React, { useEffect, useState } from "react";
import {
  Input,
  PaymentSection,
  SearchServiceInput,
  FilterDatePicker,
} from "./Input/Input";
import { Dropzone } from "../Dropzone/Dropzone";
import * as forms from "../../../assets/forms/forms";
import { ActionButton, AltButton } from "../../common/Buttons/Buttons";
import {
  phoneCodes,
  locationOptions,
  addressEnum,
  PaymentStatus,
  addressStatus,
  IVA,
  paymentType,
  userType,
  externalTowReasonsOptions,
  membershipCodes,
  enumStatus,
  paymentMethods as metodosDePago,
  referenceLocation,
  providersPaymentsTypes,
  idCodes,
  clientTypes,
  caseType,
  paymentMethods,
  validationAPIErrorCheckbox,
  craneTypeOptions,
  banksOptions,
  locksmithPayMethods,
  locksmithPayMethodOptions,
  locksmithIdCodes,
} from "../../../assets/helpers/options";
import {
  capitalize,
  validateCourtesy,
  filterOption,
  filterOptionById,
  isZelleOrPaypal,
  isCraneVehicleClass,
} from "../../../assets/helpers/funciones";
import {
  AddProvidersTableHeader,
  editServicePaymentTableHeader,
} from "../../../assets/helpers/tables";
import {
  AddProvidersTable,
  EditServicePaymentTable,
} from "../../../components/common/Tables/Tables";
import { operationsRoles, salesRoles } from "../../../assets/helpers/roles";
import { CashBackComponent } from "../Modals/LandingModals";
import { FileComponent, FileDropzone } from "../Dropzone/Dropzone";
import { PlacesAutocomplete } from "../Maps/PlacesAutocomplete";
import "./Form.scss";
import {
  parseIncidenceTemplate,
  findOptionLoose,
} from "../../../assets/helpers/parseIncidenceTemplate";
import { formatPhoneForInput } from "../../../assets/helpers/phoneHelpers";
import { notify } from "../../../assets/helpers/toast";
import {
  validateTowImages,
  validateServicePayment,
  validateBikeImages,
} from "../../../assets/helpers/caseValidations";
import authService from "../../../services/authService";
import addSquare from "../../../images/addSquare.svg";
import closeSquare from "../../../images/closeSquare.svg";
import { ProviderDropzone } from "../../views/Providers/ProvidersPayment/ProviderDropzone";

// Loose option matcher used when auto-filling selects from a pasted template.
export const LoginForm = (props) => {
  const { t, register, errors, action } = props;

  const handleSubmit = (e) => {
    e.preventDefault();
    action();
  };

  return (
    <form className="form-container" onSubmit={handleSubmit}>
      <div className="row">
        {forms.login(t, register, errors).map((l, i) => (
          <Input
            key={i}
            bootstrap={l.bootstrap}
            label={l.label}
            type={l.type}
            name={l.name}
            register={l.register}
            placeholder={l.placeholder}
            errors={l.errors}
          />
        ))}
      </div>
      <div className="buttons-center-container">
        {/* Botón submit oculto para permitir Enter */}
        <button
          type="submit"
          style={{ display: "none" }}
          tabIndex={-1}
        ></button>
        <ActionButton type="button" label={"Ingresar"} action={action} />
      </div>
    </form>
  );
};

export const LoginOTPForm = (props) => {
  const { t, register, errors, action } = props;

  const handleSubmit = (e) => {
    e.preventDefault(); // Evita el reload
    action();
  };

  return (
    <form className="form-container" onSubmit={handleSubmit}>
      <div className="row">
        {forms.loginOTP(t, register, errors).map((l, i) => (
          <Input
            key={i}
            bootstrap={l.bootstrap}
            label={l.label}
            type={l.type}
            name={l.name}
            register={l.register}
            placeholder={l.placeholder}
            errors={l.errors}
          />
        ))}
      </div>
      <div className="buttons-center-container">
        <ActionButton action={action} label={"Ingresar"} />
      </div>
    </form>
  );
};

export const FollowingForm = (props) => {
  const { t, register, errors, action } = props;

  return (
    <form className="form-container">
      <div className="row">
        {forms.following(t, register, errors).map((l, i) => (
          <Input
            key={i}
            bootstrap={l.bootstrap}
            label={l.label}
            type={l.type}
            name={l.name}
            register={l.register}
            placeholder={l.placeholder}
            errors={l.errors}
            data={l}
          />
        ))}
      </div>
      <div className="buttons-center-container">
        <ActionButton action={action} label={"Aceptar"} />
      </div>
    </form>
  );
};

export const CancelCaseForm = (props) => {
  const { register, errors, action, cancel, cancelOptions } = props;

  return (
    <form className="form-container">
      <div className="row">
        <Input
          bootstrap={"col-12"}
          label={"Motivo de cancelación*"}
          type={"select"}
          options={cancelOptions}
          name={"cancelationReason"}
          register={register}
          placeholder={""}
          errors={errors?.cancelationReason?.message}
        />{" "}
        <Input
          bootstrap={"col-12"}
          label={"Observación"}
          type={"textarea"}
          name={"cancelationReasonDescription"}
          register={register}
          placeholder={""}
          errors={errors?.cancelationReasonDescription?.message}
        />
      </div>

      <div className="buttons-center-container">
        <h6>¿ Esta seguro que desea cancelar el caso ?</h6>
      </div>
      <div className="buttons-center-container">
        <AltButton action={cancel} label={"No"} />
        <ActionButton action={action} label={"Si"} />
      </div>
    </form>
  );
};

export const ActivateDriverForm = (props) => {
  const { register, errors, options, watch } = props;

  return (
    <form className="form-container">
      <div className="row">
        <Input
          bootstrap={"col-12"}
          label={"Unidad Seleccionada*"}
          type={"select"}
          options={options}
          name={"vehicle"}
          register={register}
          placeholder={""}
          errors={errors?.vehicle?.message}
          disabled={filterOptionById(options, watch("vehicle"))?.provider}
          capitalizeOff={true}
        />{" "}
      </div>
    </form>
  );
};

export const FailedCaseForm = (props) => {
  const { register, errors, action, cancel } = props;

  return (
    <form className="form-container">
      <div className="row">
        <Input
          bootstrap={"col-12"}
          label={"Motivo*"}
          type={"textarea"}
          name={"failedReason"}
          register={register}
          placeholder={""}
          errors={errors?.failedReason?.message}
        />{" "}
      </div>

      <div className="buttons-center-container">
        <h6>¿ Esta seguro que desea marcar el caso como fallido ?</h6>
      </div>
      <div className="buttons-center-container">
        <AltButton action={cancel} label={"No"} />
        <ActionButton action={action} label={"Si"} />
      </div>
    </form>
  );
};

export const CancelServiceForm = (props) => {
  const { register, errors, action, cancel, cancelOptions } = props;

  return (
    <form className="form-container">
      <div className="row">
        <Input
          bootstrap={"col-12"}
          label={"Motivo de cancelación*"}
          type={"select"}
          options={cancelOptions}
          name={"cancellationReason"}
          register={register}
          placeholder={""}
          errors={errors?.cancellationReason?.message}
        />{" "}
        <Input
          bootstrap={"col-12"}
          label={"Observación"}
          type={"textarea"}
          name={"cancellationDescription"}
          register={register}
          placeholder={""}
          errors={errors?.cancellationDescription?.message}
        />
      </div>

      <div className="buttons-center-container">
        <h6>¿ Esta seguro que desea cancelar el servicio ?</h6>
      </div>
      <div className="buttons-center-container">
        <AltButton action={cancel} label={"No"} />
        <ActionButton action={action} label={"Si"} />
      </div>
    </form>
  );
};

const PendingLoadInfoMessage = ({ children }) => (
  <div className="pending-load-info-message">
    <span className="pending-load-info-message__icon" aria-hidden="true">
      i
    </span>
    <p>{children}</p>
  </div>
);

export const FinishServiceForm = (props) => {
  const {
    register,
    errors,
    action,
    cancel,
    options,
    actionLabel,
    modal,
    setValue,
  } = props;

  const _case = modal?.selected;
  const validationOptions = { ignoreStage: true };
  const hasPendingPayment = validateServicePayment(_case, validationOptions);
  const hasPendingImages =
    validateTowImages(_case, validationOptions) ||
    validateBikeImages(_case, validationOptions);

  return (
    <form className="form-container">
      {![enumStatus?.FOLLOW_UP, enumStatus?.CUSTOMER_ON_ROAD, enumStatus?.PENDING_LOAD]?.includes(modal?.selected?.status) && (
        <div className="row">
          <Input
            bootstrap={"col-12"}
            label={"Avería real *"}
            type={"select-mobile"}
            options={options}
            name={"providerFailureReason"}
            onChange={(e) => {
              register("providerFailureReason").onChange(e);
              setValue("providerFailureReason", e.target.value);
            }}
            register={register}
            placeholder={""}
            errors={errors?.providerFailureReason?.message}
          />
          <Input
            bootstrap={"col-12"}
            label={"Explique: *"}
            type={"textarea"}
            name={"providerFailureDescription"}
            register={register}
            placeholder={""}
            errors={errors?.providerFailureDescription?.message}
          />
        </div>
      )}

      {hasPendingPayment && (
        <PendingLoadInfoMessage>
          El caso pasará al estatus <strong>"carga pendiente"</strong> ya que tiene
          un pago pendiente por cobrar.
        </PendingLoadInfoMessage>
      )}

      {hasPendingImages && (
        <PendingLoadInfoMessage>
          El caso pasará al estatus <strong>"carga pendiente"</strong> ya que tiene
          imágenes pendientes por cargar.
        </PendingLoadInfoMessage>
      )}

      <div className="buttons-center-container">
        <h6>¿ Esta seguro que desea finalizar el servicio ?</h6>
      </div>
      <div className="buttons-center-container">
        {!modal?.thirdParty && <AltButton action={cancel} label={"No"} />}
        <ActionButton action={action} label={actionLabel} />
      </div>
    </form>
  );
};

export const FailureAssignForm = (props) => {
  const { register, errors, action, cancel, options, actionLabel, setValue } =
    props;

  return (
    <form className="form-container">
      <div className="row">
        <Input
          bootstrap={"col-12"}
          label={"Avería real *"}
          type={"select-mobile"}
          options={options}
          name={"providerFailureReason"}
          onChange={(e) => {
            register("providerFailureReason").onChange(e);
            setValue("providerFailureReason", e.target.value);
          }}
          register={register}
          placeholder={""}
          errors={errors?.providerFailureReason?.message}
        />
        <Input
          bootstrap={"col-12"}
          label={"Explique: *"}
          type={"textarea"}
          name={"providerFailureDescription"}
          register={register}
          placeholder={""}
          errors={errors?.providerFailureDescription?.message}
        />
      </div>

      <div className="buttons-center-container">
        <h6>¿ Esta seguro que desea actualizar el servicio ?</h6>
      </div>
      <div className="buttons-center-container">
        <AltButton action={cancel} label={"No"} />
        <ActionButton action={action} label={actionLabel} />
      </div>
    </form>
  );
};

export const ProvidersPaymenForm = (props) => {
  const {
    watch,
    modal,
    register,
    errors,
    action,
    cancel,
    options,
    onChange,
    control,
    type,
    fileUploaded,
    removeFile,
    onDrop,
    showErrorAPI,
  } = props;

  const renderSkipApiCheckbox = (slotIndex) => {
    const methodName = filterOptionById(
      options?.paymentMethods,
      watch(`method${slotIndex}`)
    )?.name;
    if (
      !validationAPIErrorCheckbox.includes(methodName) ||
      !showErrorAPI ||
      !authService.getUser()
    ) {
      return null;
    }
    return (
      <div
        className="col-12"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "10px",
        }}
      >
        <h6 style={{ color: "red", marginRight: "10px", marginBottom: "0" }}>
          No Validado por API
        </h6>
        <Input
          bootstrap={""}
          label={""}
          type={"checkbox"}
          name={`skipApiValidationError${slotIndex}`}
          register={register}
          placeholder={""}
          errors={errors?.[`skipApiValidationError${slotIndex}`]?.message}
          disabled={false}
        />
      </div>
    );
  };

  return (
    <form className="providers-payment-form-container">
      <div className="row">
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Número de Factura"}
          type={"text"}
          name={"billNumber"}
          register={register}
          placeholder={""}
          errors={errors?.billNumber?.message}
        />
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Cantidad de métodos de pago *"}
          type={"select"}
          options={options?.paymentMethodsQuantity}
          name={"providerMethods"}
          register={register}
          placeholder={""}
          onChange={onChange?.handleMethodsChange}
          errors={errors?.providerMethods?.message}
        />
        {type === providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW && (
          <>
            <Input
              bootstrap={"col-12 col-md-6"}
              label={"Fecha de pago"}
              type={"date"}
              name={"providerPaidDate"}
              register={register}
              placeholder={""}
              errors={errors?.providerPaidDate?.message}
              control={control}
            />

            <Input
              bootstrap={"col-12 col-md-6"}
              label={"Tasa de cambio"}
              type={"text"}
              options={options?.paymentMethodsQuantity}
              name={"exchangeRate"}
              register={register}
              placeholder={""}
              onChange={onChange?.handleMethodsChange}
              errors={errors?.exchangeRate?.message}
              disabled={true}
            />
          </>
        )}

        <div className="col-12">
          <h6 style={{ textAlign: "center" }}>
            {modal?.affiliatedPayment
              ? `Monto de afiliados: ${modal?.affiliatedPayment}$`
              : ""}
          </h6>
          <h6 style={{ textAlign: "center" }}>
            {modal?.particularPayment
              ? `Monto de particulares: ${modal?.particularPayment}$`
              : ""}
          </h6>
          <h5 style={{ textAlign: "center" }}>
            Total a pagar{" "}
            <b>
              {watch("billNumber")
                ? ((modal?.totalAmount * (100 + IVA)) / 100)?.toFixed(2)
                : modal?.totalAmount?.toFixed(2)}
              ${" "}
            </b>{" "}
          </h5>
          <p style={{ textAlign: "center", color: "red" }}>
            {watch("billNumber") ? `Incluye IVA ${IVA}% ` : ""}
          </p>
        </div>
        <br />

        {/* Methodo 1 */}
        <br />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Método de pago 1 *"}
          type={"select"}
          options={options?.paymentMethods}
          name={"method1"}
          register={register}
          placeholder={""}
          errors={errors?.method1?.message}
          onChange={() => onChange?.handleProviderMethodChange?.(1)}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Monto 1 *"}
          type={"number"}
          name={"amount1"}
          register={register}
          placeholder={""}
          onChange={() => onChange?.handleAmountChange("1")}
          errors={errors?.amount1?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Monto  1 BsS *"}
          type={"number"}
          name={"amountBsS1"}
          register={register}
          placeholder={""}
          errors={errors?.amountBsS1?.message}
        />

        {type === providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW && (
          <>
            {fileUploaded[0] ? (
              <FileComponent
                file={fileUploaded[0]}
                remove={() => removeFile(0)}
              />
            ) : (
              <ProviderDropzone
                onDrop={onDrop}
                message={"(PNG, JPG, JEPG, máx. 5MB)"}
                index={0}
              />
            )}
            <Input
              bootstrap={"col-12 col-md-12"}
              label={"Referencia 1 *"}
              type={"text"}
              name={"reference0"}
              register={register}
              placeholder={""}
              errors={errors?.reference1?.message}
            />
          </>
        )}
        {renderSkipApiCheckbox(1)}
        <hr />
        {/* Methodo 2 */}
        {watch("providerMethods") > 1 && (
          <>
            <Input
              bootstrap={"col-12 col-md-4"}
              label={"Método de pago 2 *"}
              type={"select"}
              options={options?.paymentMethods}
              name={"method2"}
              register={register}
              placeholder={""}
              errors={errors?.method2?.message}
              onChange={() => onChange?.handleProviderMethodChange?.(2)}
            />
            <br />
            <Input
              bootstrap={"col-12 col-md-4"}
              label={"Monto 2 *"}
              type={"number"}
              name={"amount2"}
              register={register}
              placeholder={""}
              onChange={() => onChange?.handleAmountChange("2")}
              errors={errors?.amount2?.message}
            />
            <Input
              bootstrap={"col-12 col-md-4"}
              label={"Monto 2 BsS *"}
              type={"number"}
              name={"amountBsS2"}
              register={register}
              placeholder={""}
              errors={errors?.amountBsS2?.message}
            />
            {type === providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW && (
              <>
                {fileUploaded[1] ? (
                  <FileComponent
                    file={fileUploaded[1]}
                    remove={() => removeFile(1)}
                  />
                ) : (
                  <ProviderDropzone
                    onDrop={onDrop}
                    message={"(PNG, JPG, JEPG, máx. 5MB)"}
                    index={1}
                  />
                )}
                <Input
                  bootstrap={"col-12 col-md-12"}
                  label={"Referencia 2 *"}
                  type={"text"}
                  name={"reference1"}
                  register={register}
                  placeholder={""}
                  errors={errors?.reference2?.message}
                />
              </>
            )}
            {renderSkipApiCheckbox(2)}
          </>
        )}
        <Input
          bootstrap={"col-12 "}
          label={"¿Deseas agregar alguna observación?"}
          type={"textarea"}
          name={"observation"}
          register={register}
          placeholder={""}
          errors={errors?.observation?.message}
        />
      </div>

      <div className="buttons-center-container">
        <h6>¿ Está seguro de gestionar este pago ?</h6>
      </div>
      <div className="buttons-center-container">
        <AltButton action={cancel} label={"No"} />
        <ActionButton action={action} label={"Si"} />
      </div>
    </form>
  );
};

export const NewCraneProviderForm = (props) => {
  const { watch, register, errors, action, cancel, options, onChange } = props;

  return (
    <form className="form-container">
      <div className="row">
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Nombre de la empresa: *"}
          type={"text"}
          name={'companyName'}
          register={register}
          placeholder={"Nombre de la empresa"}
          errors={errors?.companyName?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Nombre y Apellido *"}
          type={"text"}
          name={"contactName"}
          register={register}
          placeholder={"Nombre y Apellido"}
          errors={errors?.contactName?.message}
        />
        <Input
          bootstrap={"col-4 col-sm-2 col-md-1"}
          label={"C.I / RIF*"}
          type={"select"}
          options={idCodes}
          name={"identificationType"}
          register={register}
          placeholder={"C.I / RIF*"}
          errors={errors?.identificationType?.message}
        />
        <Input
          bootstrap={"col-8 col-sm-4 col-md-3"}
          label={" "}
          type={"number"}
          name={"identification"}
          register={register}
          placeholder={""}
          errors={errors?.identification?.message}
        />
        <Input
          bootstrap={"col-4 col-sm-2 col-md-1"}
          label={"Teléfono *"}
          type={"select"}
          options={phoneCodes}
          name={"phonePrefix"}
          register={register}
          placeholder={""}
          errors={errors?.phonePrefix?.message}
        />
        <Input
          bootstrap={"col-8 col-sm-4 col-md-3"}
          label={" "}
          type={"number"}
          name={"phoneNumber"}
          register={register}
          placeholder={""}
          errors={errors?.phoneNumber?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Estado donde presta servicio*"}
          type={"select"}
          name={"state"}
          register={register}
          options={options?.statesOptions}
          placeholder={""}
          errors={errors?.state?.message}
          onChange={() => onChange?.getCities(watch("state"))}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Ciudad donde presta servicio*"}
          type={"select"}
          name={"city"}
          register={register}
          options={options?.citiesOptions}
          placeholder={""}
          errors={errors?.city?.message}
          disabled={!watch("state")}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Estatus"}
          type={"select"}
          name={"isActive"}
          register={register}
          options={options?.prodiverStatys}
          placeholder={""}
          errors={errors?.isActive?.message}
        />



      </div>
      <div className="buttons-center-container">
        <AltButton action={cancel} label={"Cancelar"} />
        <ActionButton action={action} label={"Ingresar"} />
      </div>
    </form>
  );
};

export const NewVehicularAssetForm = (props) => {
  const {
    control,
    register,
    errors,
    action,
    cancel,
    options,
    watch,
    onChange,
    getRootProps,
    getInputProps,
    getRootProps2,
    getInputProps2,
    rcv,
    propertyTitle,
  } = props;

  return (
    <form className="form-container">
      <div className="row">
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Tipo *"}
          type={"select"}
          options={options?.vehicleClassesOptions}
          name={"class"}
          placeholder={"Seleccione"}
          register={register}
          errors={errors?.class?.message}
          onChange={onChange?.handleVehicleType}
        />
        {isCraneVehicleClass(
          filterOptionById(options?.vehicleClassesOptions, watch("class"))
        ) && (
            <Input
              bootstrap={"col-12 col-md-4"}
              label={"Tipo de Grúa *"}
              type={"select"}
              options={craneTypeOptions}
              name={"type"}
              placeholder={"Seleccione"}
              register={register}
              errors={errors?.type?.message}
              capitalizeOff
            />
          )}
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Marca *"}
          type={"select"}
          options={options?.brandOptions}
          name={"brand"}
          placeholder={"Seleccione"}
          register={register}
          errors={errors?.brand?.message}
          onChange={onChange?.getVehicleModels}
          disabled={!watch("class") || options?.brandOptions?.length === 0}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Modelo *"}
          type={"select"}
          options={options?.modelOptions}
          name={"model"}
          placeholder={"Seleccione"}
          register={register}
          errors={errors?.model?.message}
          disabled={!watch("brand") || options?.modelOptions?.length === 0}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Placa *"}
          type={"text"}
          name={"plate"}
          placeholder={""}
          register={register}
          errors={errors?.plate?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Color *"}
          type={"text"}
          name={"color"}
          placeholder={""}
          register={register}
          errors={errors?.color?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Año *"}
          type={"number"}
          name={"year"}
          placeholder={""}
          register={register}
          errors={errors?.year?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Fecha de compra *"}
          type={"date"}
          name={"purchaseDate"}
          placeholder={""}
          register={register}
          errors={errors?.purchaseDate?.message}
          control={control}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Alias *"}
          type={"text"}
          name={"alias"}
          placeholder={""}
          register={register}
          errors={errors?.alias?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Descripción"}
          type={"textarea"}
          name={"description"}
          placeholder={""}
          register={register}
          errors={errors?.description?.message}
        />

        <div className="col-12 col-md-4">
          <div className={`input-component-container`}>
            <label htmlFor="">Titulo de Propiedad</label>
          </div>
          {propertyTitle[0] ? (
            <FileComponent
              file={propertyTitle[0]}
            // remove={() => removeFile(0)}
            />
          ) : (
            <Dropzone
              getRootProps={getRootProps}
              getInputProps={getInputProps}
              message={"(PNG, JPG, JEPG, máx. 5MB)"}
            />
          )}
        </div>

        <div className="col-12 col-md-4">
          <div className={`input-component-container`}>
            <label htmlFor="">RCV</label>
          </div>
          {rcv[0] ? (
            <FileComponent
              file={rcv[0]}
            // remove={() => removeFile(0)}
            />
          ) : (
            <Dropzone
              getRootProps={getRootProps2}
              getInputProps={getInputProps2}
              message={"(PNG, JPG, JEPG, máx. 5MB)"}
            />
          )}
        </div>

        <h2>Proveedores asociados</h2>
        <div className="row">
          <Input
            bootstrap={"col-12 col-md-4"}
            label={"Agregar Proveedor"}
            type={"select"}
            name={"provider"}
            options={options?.internalProvidersOptions}
            placeholder={""}
            register={register}
            errors={errors?.provider?.message}
            disabled={options?.internalProvidersOptions?.length === 0}
          />
          <div className="col-md-4">
            <div style={{ marginTop: "32px" }} className="buttons-container">
              <ActionButton
                disabled={!watch("provider")}
                action={onChange.addProvider}
                label={"Agregar proveedor"}
              />
            </div>
          </div>
        </div>
        <AddProvidersTable
          header={AddProvidersTableHeader}
          data={options.selectedProviders}
          removeProvider={onChange?.removeProvider}
        />
      </div>
      <div style={{ marginTop: "48px" }} className="buttons-center-container">
        <AltButton action={cancel} label={"Cancelar"} />
        <ActionButton action={action} label={"Ingresar Vehiculo"} />
      </div>
    </form>
  );
};

export const EditVehicularAssetForm = (props) => {
  const {
    control,
    register,
    errors,
    action,
    cancel,
    options,
    watch,
    onChange,
    getRootProps,
    getInputProps,
    getRootProps2,
    getInputProps2,
    rcv,
    propertyTitle,
  } = props;

  return (
    <form className="form-container">
      <div className="row">
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Tipo *"}
          type={"select"}
          options={options?.vehicleClassesOptions}
          name={"class"}
          placeholder={"Seleccione"}
          register={register}
          errors={errors?.class?.message}
          onChange={onChange?.handleVehicleType}
        />
        {isCraneVehicleClass(
          filterOptionById(options?.vehicleClassesOptions, watch("class"))
        ) && (
            <Input
              bootstrap={"col-12 col-md-4"}
              label={"Tipo de Grúa *"}
              type={"select"}
              options={craneTypeOptions}
              name={"type"}
              placeholder={"Seleccione"}
              register={register}
              errors={errors?.type?.message}
              capitalizeOff
            />
          )}
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Marca *"}
          type={"select"}
          options={options?.brandOptions}
          name={"brand"}
          placeholder={"Seleccione"}
          register={register}
          errors={errors?.brand?.message}
          onChange={(e) => onChange?.getVehicleModels(e?.target?.value)}
          disabled={!watch("class") || options?.brandOptions?.length === 0}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Modelo *"}
          type={"select"}
          options={options?.modelOptions}
          name={"model"}
          placeholder={"Seleccione"}
          register={register}
          errors={errors?.model?.message}
          disabled={!watch("brand") || options?.modelOptions?.length === 0}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Placa *"}
          type={"text"}
          name={"plate"}
          placeholder={""}
          register={register}
          errors={errors?.plate?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Color *"}
          type={"text"}
          name={"color"}
          placeholder={""}
          register={register}
          errors={errors?.color?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Año *"}
          type={"number"}
          name={"year"}
          placeholder={""}
          register={register}
          errors={errors?.year?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Fecha de compra *"}
          type={"date"}
          name={"purchaseDate"}
          placeholder={""}
          register={register}
          errors={errors?.purchaseDate?.message}
          control={control}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Alias *"}
          type={"text"}
          name={"alias"}
          placeholder={""}
          register={register}
          errors={errors?.alias?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Descripción"}
          type={"textarea"}
          name={"description"}
          placeholder={""}
          register={register}
          errors={errors?.description?.message}
        />
        <div className="col-12 col-md-4">
          <div className={`input-component-container`}>
            <label htmlFor="">Titulo de Propiedad</label>
          </div>
          {propertyTitle[0] ? (
            <FileComponent
              file={propertyTitle[0]}
            // remove={() => removeFile(0)}
            />
          ) : (
            <Dropzone
              getRootProps={getRootProps}
              getInputProps={getInputProps}
              message={"(PNG, JPG, JEPG, máx. 5MB)"}
            />
          )}
        </div>

        <div className="col-12 col-md-4">
          <div className={`input-component-container`}>
            <label htmlFor="">RCV</label>
          </div>
          {rcv[0] ? (
            <FileComponent
              file={rcv[0]}
            // remove={() => removeFile(0)}
            />
          ) : (
            <Dropzone
              getRootProps={getRootProps2}
              getInputProps={getInputProps2}
              message={"(PNG, JPG, JEPG, máx. 5MB)"}
            />
          )}
        </div>

        <h2>Proveedores asociados</h2>
        <div className="row">
          <Input
            bootstrap={"col-12 col-md-4"}
            label={"Agregar Proveedor"}
            type={"select"}
            name={"provider"}
            options={options?.internalProvidersOptions}
            placeholder={""}
            register={register}
            errors={errors?.provider?.message}
            disabled={options?.internalProvidersOptions?.length === 0}
          />
          <div className="col-md-4">
            <div style={{ marginTop: "32px" }} className="buttons-container">
              <ActionButton
                disabled={!watch("provider")}
                action={onChange.addProvider}
                label={"Agregar proveedor"}
              />
            </div>
          </div>
        </div>

        <AddProvidersTable
          header={AddProvidersTableHeader}
          data={options.selectedProviders}
          removeProvider={onChange?.removeProvider}
        />
      </div>
      <div className="buttons-center-container">
        <AltButton action={cancel} label={"Cancelar"} />
        <ActionButton action={action} label={"Guardar"} />
      </div>
    </form>
  );
};

export const EditExternalProviderForm = (props) => {
  const { register, errors, action, options, cancel, watch, onChange } = props;

  return (
    <form className="form-container">
      <div className="row">
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Nombre de la empresa: *"}
          type={"text"}
          name={'companyName'}
          register={register}
          placeholder={"Nombre de la empresa"}
          errors={errors?.companyName?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Nombre y Apellido *"}
          type={"text"}
          name={"contactName"}
          register={register}
          placeholder={"Nombre y Apellido"}
          errors={errors?.contactName?.message}
        />
        <Input
          bootstrap={"col-4 col-sm-2 col-md-1"}
          label={"C.I / RIF*"}
          type={"select"}
          options={idCodes}
          name={"identificationType"}
          register={register}
          placeholder={"C.I / RIF*"}
          errors={errors?.identificationType?.message}
        />
        <Input
          bootstrap={"col-8 col-sm-4 col-md-3"}
          label={" "}
          type={"number"}
          name={"identification"}
          register={register}
          placeholder={""}
          errors={errors?.identification?.message}
        />
        <Input
          bootstrap={"col-4 col-sm-2 col-md-1"}
          label={"Teléfono *"}
          type={"select"}
          options={phoneCodes}
          name={"phonePrefix"}
          register={register}
          placeholder={""}
          errors={errors?.phonePrefix?.message}
        />
        <Input
          bootstrap={"col-8 col-sm-4 col-md-3"}
          label={" "}
          type={"number"}
          name={"phoneNumber"}
          register={register}
          placeholder={""}
          errors={errors?.phoneNumber?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Estado donde presta servicio*"}
          type={"select"}
          name={"state"}
          register={register}
          options={options?.statesOptions}
          placeholder={""}
          errors={errors?.state?.message}
          onChange={() => onChange?.getCities(watch("state"))}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Ciudad donde presta servicio*"}
          type={"select"}
          name={"city"}
          register={register}
          options={options?.citiesOptions}
          placeholder={""}
          errors={errors?.city?.message}
          disabled={!watch("state")}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Estatus"}
          type={"select"}
          name={"isActive"}
          register={register}
          options={options?.prodiverStatys}
          placeholder={""}
          errors={errors?.isActive?.message}
        />
      </div>
      <div className="buttons-center-container">
        <AltButton action={cancel} label={"Cancelar"} />
        <ActionButton action={action} label={"Guardar"} />
      </div>
    </form>
  );
};

export const EditInternalProviderForm = (props) => {
  const { t, register, errors, action, options, cancel } = props;

  return (
    <form className="form-container">
      <div className="row">
        {forms
          .newInternalProviderForm(t, register, errors, options)
          .map((l, i) => (
            <Input
              key={i}
              title={l?.title}
              bootstrap={l?.bootstrap}
              label={l?.label}
              type={l?.type}
              name={l?.name}
              register={l?.register}
              placeholder={l?.placeholder}
              errors={l?.errors}
              data={l}
            />
          ))}
      </div>
      <div className="buttons-center-container">
        <AltButton action={cancel} label={"Cancelar"} />
        <ActionButton action={action} label={"Guardar"} />
      </div>
    </form>
  );
};

export const ApprovalPaymentForm = (props) => {
  const { t, control, register, errors, action, cancel } = props;

  return (
    <form className="form-container">
      <div className="row">
        {forms.approvalPaymentForm(t, register, errors).map((l, i) => (
          <Input
            key={i}
            title={l?.title}
            bootstrap={l?.bootstrap}
            label={l?.label}
            type={l?.type}
            name={l?.name}
            register={l?.register}
            placeholder={l?.placeholder}
            errors={l?.errors}
            data={l}
            control={control}
          />
        ))}
      </div>
      <div className="buttons-center-container">
        <AltButton action={cancel} label={"Cancelar"} />
        <ActionButton action={action} label={"Guardar"} />
      </div>
    </form>
  );
};

export const CreateParticularCustomertForm = (props) => {
  const { t, register, errors, action, options, onChange, getValues, watch, control } =
    props;

  return (
    <form className="form-container">
      <div className="row">
        {forms
          .CreateParticularCustomertForm(
            t,
            register,
            errors,
            options,
            onChange,
            watch,
            control
          )
          .map((l, i) => (
            <Input
              key={i}
              title={l?.title}
              bootstrap={l?.bootstrap}
              label={l?.label}
              type={l?.type}
              name={l?.name}
              register={l?.register}
              control={l?.control || control}
              placeholder={l?.placeholder}
              errors={l?.errors}
              data={l}
              disabled={l?.disabled}
              numpadForMobile={true}
            />
          ))}
      </div>
      <div style={{ margin: "24px 0px" }} className="buttons-center-container">
        <AltButton action={action} label={"Guardar"} />
      </div>
    </form>
  );
};

export const EditParticularCustomertForm = (props) => {
  const { register, errors, action, options, onChange, watch, control } = props;

  return (
    <form className="form-container">
      <div className="row">
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Nombre *"}
          type={"text"}
          name={"firstName"}
          register={register}
          placeholder={""}
          errors={errors?.firstName?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Apellido *"}
          type={"text"}
          name={"lastName"}
          register={register}
          placeholder={""}
          errors={errors?.lastName?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Teléfono *"}
          type={"phone"}
          name={"phone"}
          control={control}
          register={register}
          placeholder={""}
          errors={errors?.phone?.message}
          numpadForMobile={true}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Marca del Vehículo *"}
          type={"select"}
          name={"vehicleBrand"}
          options={options?.vehicleBrandOptions}
          register={register}
          placeholder={""}
          onChange={() => onChange?.getVehicleModels(watch("vehicleBrand"))}
          errors={errors?.vehicleBrand?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Modelo del vehículo *"}
          type={"select"}
          name={"vehicleModel"}
          options={options?.vehicleModelOptions}
          register={register}
          placeholder={""}
          errors={errors?.vehicleModel?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Color del vehículo *"}
          type={"text"}
          name={"vehicleColor"}
          register={register}
          placeholder={""}
          errors={errors?.vehicleColor?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Año *"}
          type={"number"}
          name={"vehicleYear"}
          register={register}
          placeholder={""}
          errors={errors?.vehicleYear?.message}
        />
        <Input
          bootstrap={"col-12 col-md-4"}
          label={"Placa *"}
          type={"text"}
          name={"vehiclePlate"}
          register={register}
          placeholder={""}
          errors={errors?.vehiclePlate?.message}
        />
      </div>
      <div style={{ margin: "24px 0px" }} className="buttons-center-container">
        <AltButton action={action} label={"Editar"} />
      </div>
    </form>
  );
};

export const NewInternalProviderForm = (props) => {
  const { t, register, errors, action, cancel, options } = props;

  return (
    <form className="form-container">
      <div className="row">
        {forms
          .newInternalProviderForm(t, register, errors, options)
          .map((l, i) => (
            <Input
              key={i}
              title={l?.title}
              bootstrap={l?.bootstrap}
              label={l?.label}
              type={l?.type}
              name={l?.name}
              register={l?.register}
              placeholder={l?.placeholder}
              errors={l?.errors}
              data={l}
            />
          ))}
      </div>
      <div className="buttons-center-container">
        <AltButton action={cancel} label={"Cancelar"} />
        <ActionButton action={action} label={"Guardar"} />
      </div>
    </form>
  );
};

export const CardCaseInfoForm = (props) => {
  const { t, register, errors, action, cancel, options, control } = props;

  return (
    <form className="form-container">
      <div className="container" style={{ width: "100%" }}>
        <div className="row">
          {forms.carCaseInfo1(t, register, errors, options).map((l, i) => (
            <Input
              key={i}
              title={l?.title}
              bootstrap={l?.bootstrap}
              label={l?.label}
              type={l?.type}
              name={l?.name}
              register={l?.register}
              placeholder={l?.placeholder}
              errors={l?.errors}
              data={l}
            />
          ))}
        </div>
        <div className="gray-line"></div>
        <div className="row">
          {forms
            .carCaseInfo2(t, register, errors, options, control)
            .map((l, i) => (
              <Input
                key={i}
                title={l?.title}
                bootstrap={l?.bootstrap}
                label={l?.label}
                type={l?.type}
                name={l?.name}
                register={l?.register}
                placeholder={l?.placeholder}
                errors={l?.errors}
                control={control}
                data={l}
              />
            ))}
        </div>
        <br />
        <div className="gray-line"></div>
        <br />
        <div className="row small-input-label">
          {forms.carCaseInfo3(t, register, errors, options).map((l, i) => (
            <Input
              key={i}
              title={l?.title}
              bootstrap={l?.bootstrap}
              label={l?.label}
              type={l?.type}
              name={l?.name}
              register={l?.register}
              placeholder={l?.placeholder}
              errors={l?.errors}
              data={l}
            />
          ))}
        </div>
        <br />
        <div className="gray-line"></div>
        <br />
        <div className="row small-input-label">
          {forms.carCaseInfo4(t, register, errors, options).map((l, i) => (
            <Input
              key={i}
              title={l?.title}
              bootstrap={l?.bootstrap}
              label={l?.label}
              type={l?.type}
              name={l?.name}
              register={l?.register}
              placeholder={l?.placeholder}
              errors={l?.errors}
              data={l}
            />
          ))}
        </div>
        <br />
        <div className="gray-line"></div>
        <br />
        <div className="row small-input-label">
          {forms.carCaseInfo5(t, register, errors, options).map((l, i) => (
            <Input
              key={i}
              title={l?.title}
              bootstrap={l?.bootstrap}
              label={l?.label}
              type={l?.type}
              name={l?.name}
              register={l?.register}
              placeholder={l?.placeholder}
              errors={l?.errors}
              data={l}
            />
          ))}
        </div>
        <br />
        <div className="gray-line"></div>
        <br />
        <div className="row small-input-label">
          {forms.carCaseInfo6(t, register, errors, options).map((l, i) => (
            <Input
              key={i}
              title={l?.title}
              bootstrap={l?.bootstrap}
              label={l?.label}
              type={l?.type}
              name={l?.name}
              register={l?.register}
              placeholder={l?.placeholder}
              errors={l?.errors}
              data={l}
            />
          ))}
        </div>
        <br />
        <div className="gray-line"></div>
        <br />
        <div className="row">
          {forms.carCaseInfo7(t, register, errors, options).map((l, i) => (
            <Input
              key={i}
              title={l?.title}
              bootstrap={l?.bootstrap}
              label={l?.label}
              type={l?.type}
              name={l?.name}
              register={l?.register}
              placeholder={l?.placeholder}
              errors={l?.errors}
              data={l}
            />
          ))}
        </div>
        <div className="buttons-center-container">
          <AltButton action={cancel} label={"Cancelar"} />
          <ActionButton action={action} label={"Completar Formulario"} />
        </div>
      </div>
    </form>
  );
};

export const RegisterForm = (props) => {
  const { t, register, errors } = props;

  return (
    <form>
      <div className="row">
        {forms.register(t, register, errors).map((l, i) => (
          <Input
            key={l.name}
            bootstrap={l.bootstrap}
            label={l.label}
            type={l.type}
            name={l.name}
            register={l.register}
            placeholder={l.placeholder}
            errors={l.errors}
          />
        ))}
      </div>
    </form>
  );
};

export const ScheduleServicesForm = (props) => {
  const { t, register, errors, action, control } = props;

  return (
    <form>
      <div className="row">
        {forms.scheduleService(t, register, errors).map((l, i) => (
          <Input
            key={l.name}
            data={l}
            bootstrap={l.bootstrap}
            label={l.label}
            type={l.type}
            name={l.name}
            register={l.register}
            placeholder={l.placeholder}
            errors={l.errors}
            control={control}
          />
        ))}
      </div>
      <div className="buttons-center-container">
        <ActionButton action={action} label={"Agendar servicio"} />
      </div>
    </form>
  );
};

export const ScheduleTowForm = (props) => {
  const { t, register, errors, action, control } = props;

  return (
    <form>
      <div className="row">
        {forms.scheduleTow(t, register, errors).map((l, i) => (
          <Input
            key={l.name}
            data={l}
            bootstrap={l.bootstrap}
            label={l.label}
            type={l.type}
            name={l.name}
            register={l.register}
            placeholder={l.placeholder}
            errors={l.errors}
            control={control}
          />
        ))}
      </div>
      <div className="buttons-center-container">
        <ActionButton action={action} label={"Agendar servicio de grúa"} />
      </div>
    </form>
  );
};

export const CreateParticularCaseForm = (props) => {
  const {
    register,
    handleSubmit,
    errors,
    onChange,
    options,
    watch,
    openMapModal,
    clientSearch,
    suggestion,
    clientType,
    setValue,
    control,
  } = props;

  // After we set originState/destinyState from the template we kick off
  // onChange.getCities, which fetches the cities list asynchronously. We
  // remember the desired city name here and resolve it from the next render
  // where the matching options have arrived.
  const [pendingCity, setPendingCity] = useState({ origin: "", destiny: "" });

  React.useEffect(() => {
    if (!setValue) return;
    if (pendingCity.origin && options?.originCitiesOptions?.length) {
      const match = findOptionLoose(
        options.originCitiesOptions,
        pendingCity.origin
      );
      if (match?._id) {
        setValue("originCity", match._id);
        setPendingCity((p) => ({ ...p, origin: "" }));
      }
    }
  }, [options?.originCitiesOptions, pendingCity.origin, setValue]);

  React.useEffect(() => {
    if (!setValue) return;
    if (pendingCity.destiny && options?.destinycitiesOptions?.length) {
      const match = findOptionLoose(
        options.destinycitiesOptions,
        pendingCity.destiny
      );
      if (match?._id) {
        setValue("destinyCity", match._id);
        setPendingCity((p) => ({ ...p, destiny: "" }));
      }
    }
  }, [options?.destinycitiesOptions, pendingCity.destiny, setValue]);

  const handlePasteTemplate = async () => {
    if (!setValue) {
      notify("No es posible auto-rellenar este formulario", "error");
      return;
    }
    let raw = "";
    try {
      if (navigator?.clipboard?.readText) {
        raw = await navigator.clipboard.readText();
      } else {
        raw = window.prompt("Pega aquí el resumen de la incidencia:") || "";
      }
    } catch (e) {
      raw = window.prompt("Pega aquí el resumen de la incidencia:") || "";
    }
    if (!raw.trim()) {
      notify("No se encontró texto en el portapapeles", "error");
      return;
    }

    let parsed;
    try {
      parsed = parseIncidenceTemplate(raw);
    } catch (e) {
      notify(e.message || "El texto no tiene el formato esperado", "error");
      return;
    }

    const showsCustomerFields =
      clientType === clientTypes.ALLY || clientSearch?.selected?.papClient;
    const showsF2Fields =
      clientSearch?.selected?.code?.code === "F2" &&
      !clientSearch?.selected?.vehicle?.brand;

    if (showsCustomerFields) {
      if (parsed.firstName) setValue("firstName", capitalize(parsed.firstName));
      if (parsed.lastName) setValue("lastName", capitalize(parsed.lastName));
      if (parsed.phonePrefix || parsed.phoneNumber) {
        setValue(
          "phone",
          formatPhoneForInput(parsed.phonePrefix, parsed.phoneNumber)
        );
      }
      if (parsed.vehiclePlate) setValue("vehiclePlate", parsed.vehiclePlate);
    }
    if (showsF2Fields && parsed.vehiclePlate) {
      setValue("vehiclePlate", parsed.vehiclePlate);
    }

    if (parsed.phonePrefix || parsed.phoneNumber) {
      setValue(
        "contactPhone",
        formatPhoneForInput(parsed.phonePrefix, parsed.phoneNumber)
      );
    }

    if (parsed.faultType && options?.faultsOptions?.length) {
      // Match against options.faultsOptions by name (tolerant to case, accents
      // and minor wording differences like "Vehiculo no enciende").
      const fault = findOptionLoose(options.faultsOptions, parsed.faultType);
      if (fault?._id) {
        setValue("customerFailureReason", fault._id);
      } else {
        notify(
          `No se encontró la avería "${parsed.faultType}" en el catálogo`,
          "info"
        );
      }
    }
    const description = [parsed.faultType, parsed.faultDetail]
      .filter((v) => v && v.trim())
      .join(" - ");
    if (description) setValue("customerFailureDescription", description);

    const fillLocation = (refKey) => {
      const isOrigin = refKey === referenceLocation.ORIGIN;
      const stateName = isOrigin ? parsed.originState : parsed.destinyState;
      const cityName = isOrigin ? parsed.originCity : parsed.destinyCity;
      const address = isOrigin ? parsed.originAddress : parsed.destinyAddress;
      const link = isOrigin
        ? parsed.originLocationLink
        : parsed.destinyLocationLink;

      setValue(`${refKey}LocationStatus`, addressEnum.OTHER);
      if (isOrigin) setValue("isOriginBasement", "false");

      if (stateName && options?.statesOptions?.length) {
        const stateMatch = findOptionLoose(options.statesOptions, stateName);
        if (stateMatch?._id) {
          setValue(`${refKey}State`, stateMatch._id);
          if (typeof onChange?.getCities === "function") {
            onChange.getCities(stateMatch._id, refKey);
          }
          if (cityName) {
            setPendingCity((p) => ({ ...p, [refKey]: cityName }));
          }
        } else {
          notify(
            `No se encontró el estado "${stateName}" en el catálogo`,
            "info"
          );
        }
      }

      if (address) {
        setValue(`${refKey}Address`, address);
        const refNode = isOrigin
          ? suggestion?.originRef?.current
          : suggestion?.destinyRef?.current;
        if (refNode) refNode.value = address;
        if (typeof onChange?.updateLocationStatus === "function") {
          onChange.updateLocationStatus(refKey);
        }
      }

      if (link) setValue(`${refKey}LocationLink`, link);
    };

    fillLocation(referenceLocation.ORIGIN);
    if (!watch("withOutDestinyAddress")) {
      fillLocation(referenceLocation.DESTINY);
    }

    notify("Datos pegados desde la plantilla", "success");
  };

  return (
    <>
      <div
        className="buttons-container"
        style={{ justifyContent: "flex-end", marginBottom: "12px" }}
      >
        <AltButton
          label={"📋 Pegar desde Plantilla"}
          action={handlePasteTemplate}
        />
      </div>
      {(clientType === clientTypes.ALLY ||
        clientSearch?.selected?.papClient) && (
          <div className="row">
            {forms
              .CreateParticularCustomertForm(
                "",
                register,
                errors,
                options,
                onChange,
                watch,
                control
              )
              .map((l, i) => (
                <Input
                  key={i}
                  title={l?.title}
                  bootstrap={l?.bootstrap}
                  label={l?.label}
                  type={l?.type}
                  name={l?.name}
                  register={l?.register}
                  control={l?.control || control}
                  placeholder={l?.placeholder}
                  errors={l?.errors}
                  data={l}
                  disabled={l?.disabled}
                  numpadForMobile={true}
                />
              ))}
          </div>
        )}
      {(clientSearch?.selected?.code?.code === "F2") && !clientSearch?.selected?.vehicle?.brand && (
        <div className="row">
          {forms
            .F2ClientInfo(
              "",
              register,
              errors,
              options,
              onChange,
              watch
            )
            .map((l, i) => (
              <Input
                key={i}
                title={l?.title}
                bootstrap={l?.bootstrap}
                label={l?.label}
                type={l?.type}
                name={l?.name}
                register={l?.register}
                placeholder={l?.placeholder}
                errors={l?.errors}
                data={l}
                disabled={l?.disabled}
              />
            ))}
        </div>
      )}

      <div className="row">
        <div className="col-12 col-md-4">
          <div className="row">
            <Input
              bootstrap={"col-5"}
              label={"Dirección de origen *"}
              type={"select"}
              options={options?.addressOption}
              name={"originLocationStatus"}
              placeholder={"Seleccione"}
              register={register}
              errors={errors?.originLocationStatus?.message}
              onChange={(e) =>
                onChange?.selectGarage(e, referenceLocation?.ORIGIN)
              }
            />
            {
              <Input
                bootstrap={"col-4"}
                label={"Ubicacion *"}
                type={"select"}
                options={locationOptions}
                name={"isOriginBasement"}
                placeholder={"Seleccione"}
                register={register}
                errors={errors?.isOriginBasement?.message}
                disabled={
                  ![addressEnum.OWN, addressEnum.OTHER, ""].includes(
                    watch("originLocationStatus")
                  )
                }
              />
            }
            {[addressEnum.OWN, addressEnum.OTHER].includes(
              watch("originLocationStatus")
            ) && watch("isOriginBasement") === "true" ? (
              <Input
                bootstrap={"col-3"}
                label={"Nivel *"}
                type={"number"}
                name={"basementLevel"}
                placeholder={""}
                register={register}
                min={1}
                errors={errors?.basementLevel?.message}
              />
            ) : null}
          </div>
          <Input
            bootstrap={"col-12"}
            label={"Estado (Origen)*"}
            type={"select"}
            options={options?.statesOptions}
            name={"originState"}
            placeholder={"Seleccione"}
            register={register}
            errors={errors?.originState?.message}
            onChange={(e) => onChange?.getCities(e, referenceLocation?.ORIGIN)}
            disabled={
              ![addressEnum.OWN, addressEnum.OTHER, ""].includes(
                watch("originLocationStatus")
              )
            }
          />
          <Input
            bootstrap={"col-12"}
            label={"Ciudad (Origen)*"}
            type={"select"}
            options={options?.originCitiesOptions}
            name={"originCity"}
            placeholder={"Seleccione"}
            register={register}
            errors={errors?.originCity?.message}
            onChange={(e) =>
              onChange?.forceRecalulateDistance(e, addressStatus?.ORIGIN)
            }
            disabled={
              !watch("originState") ||
              options?.originCitiesOptions.length === 0 ||
              ![addressEnum.OWN, addressEnum.OTHER, ""].includes(
                watch("originLocationStatus")
              )
            }
          />
          {/* <Input
            bootstrap={'col-12'}
            label={'Dirección (Origen)*'}
            type={'textarea'}
            name={'originAddress'}
            placeholder={''}
            register={register}
            errors={errors?.originAddress?.message}
            onChange={e =>
              onChange?.forceRecalulateDistance(e, addressStatus?.ORIGIN)
            }
            // disabled={
            //   ![addressEnum.OWN, addressEnum.OTHER, ''].includes(
            //     watch('originLocationStatus')
            //   )
            // }
            disabled={true}
          /> */}
          <div className={`input-component-container col-12`}>
            <label htmlFor={"originRef"}>Dirección (Origen) *</label>
          </div>
          <PlacesAutocomplete restrictions={{ country: "ve" }} language="es">
            <input
              id="originRef"
              className="input-map"
              placeholder="Calle, Avenida, residencia o local"
              ref={suggestion?.originRef}
              style={{ fontSize: "12px", margin: "0px" }}
              onClick={() =>
                onChange.updateLocationStatus(referenceLocation?.ORIGIN)
              }
              onSelect={() =>
                onChange.updateLocationStatus(referenceLocation?.ORIGIN)
              }
            />
          </PlacesAutocomplete>
          <Input
            bootstrap={"col-12"}
            label={"Punto de referencia (Origen)"}
            type={"textarea"}
            name={"originReferencePoint"}
            placeholder={""}
            register={register}
            errors={errors?.originReferencePoint?.message}
          />{" "}
          <Input
            bootstrap={"col-12"}
            label={"Link de Ubicacion (Origen)"}
            type={"text"}
            name={"originLocationLink"}
            placeholder={""}
            register={register}
            errors={errors?.originLocationLink?.message}
          />{" "}
        </div>
        <div className="col-12 col-md-4">
          <div className="row">
            <Input
              bootstrap={"col-12"}
              label={"Teléfono *"}
              type={"phone"}
              name={"contactPhone"}
              control={control}
              register={register}
              placeholder={""}
              errors={errors?.contactPhone?.message}
              numpadForMobile={true}
            />
            <Input
              bootstrap={"col-12"}
              label={"Avería reportada *"}
              type={"select"}
              options={options?.faultsOptions}
              name={"customerFailureReason"}
              placeholder={""}
              register={register}
              errors={errors?.customerFailureReason?.message}
              disabled={watch("segViaje")}
            />
            <Input
              bootstrap={"col-12"}
              label={"Comentario adicional (Avería)"}
              type={"textarea"}
              name={"customerFailureDescription"}
              placeholder={""}
              register={register}
              errors={errors?.customerFailureDescription?.message}
            />
            {!watch("segViaje") && (
              <Input
                bootstrap={"col-12"}
                subLabel="Sin dirección destino"
                type={"checkbox"}
                name={"withOutDestinyAddress"}
                placeholder={""}
                register={register}
                errors={errors?.withOutDestinyAddress?.message}
                onChange={onChange?.clearDestinyData}
                disabled={
                  clientSearch?.selected?.papClient ? true : watch("usualRoute")
                }
              />
            )}
            {clientSearch?.selected?.hasThirdPartyServiceAvailable &&
              !watch("segViaje") && (
                <Input
                  bootstrap={"col-12"}
                  subLabel="Servicio de AV extendido"
                  type={"checkbox"}
                  name={"thirdPartyService"}
                  placeholder={""}
                  register={register}
                  errors={errors?.thirdPartyService?.message}
                  onChange={onChange?.clearThirdPartyData}
                  disabled={watch("usualRoute")}
                />
              )}
            {clientSearch?.selected?.code?.code === membershipCodes?.GOLD &&
              !watch("thirdPartyService") && (
                <Input
                  bootstrap={"col-12"}
                  subLabel="Seguimiento en viaje"
                  type={"checkbox"}
                  name={"segViaje"}
                  placeholder={""}
                  register={register}
                  errors={errors?.segViaje?.message}
                  onChange={onChange?.handleSegViaje}
                  disabled={watch("usualRoute")}
                />
              )}
            {clientSearch?.selected?.code?.code === membershipCodes?.GOLD &&
              !watch("thirdPartyService") && (
                <Input
                  bootstrap={"col-12"}
                  subLabel="Domicilio-Taller"
                  type={"checkbox"}
                  name={"usualRoute"}
                  placeholder={""}
                  register={register}
                  errors={errors?.usualRoute?.message}
                  disabled={
                    watch("thirdPartyService") ||
                    watch("segViaje") ||
                    watch("withOutDestinyAddress")
                  }
                />
              )}
          </div>
        </div>
        {!watch("withOutDestinyAddress") && (
          <div className="col-12 col-md-4">
            <div className="row">
              <Input
                bootstrap={"col-12"}
                label={"Dirección de Destino *"}
                type={"select"}
                options={options?.addressOption}
                name={"destinyLocationStatus"}
                placeholder={"Seleccione"}
                register={register}
                errors={errors?.destinyLocationStatus?.message}
                onChange={(e) =>
                  onChange?.selectGarage(e, referenceLocation?.DESTINY)
                }
              />
              <Input
                bootstrap={"col-12"}
                label={"Estado (Destino)*"}
                type={"select"}
                options={options?.statesOptions}
                name={"destinyState"}
                placeholder={"Seleccione"}
                register={register}
                errors={errors?.destinyState?.message}
                onChange={(e) =>
                  onChange?.getCities(e, referenceLocation?.DESTINY)
                }
                disabled={
                  ![addressEnum.OWN, addressEnum.OTHER, ""].includes(
                    watch("destinyLocationStatus")
                  )
                }
              />
              <Input
                bootstrap={"col-12"}
                label={"Ciudad (Destino)*"}
                type={"select"}
                options={options?.destinycitiesOptions}
                name={"destinyCity"}
                placeholder={"Seleccione"}
                register={register}
                errors={errors?.destinyCity?.message}
                onChange={(e) =>
                  onChange?.forceRecalulateDistance(e, addressStatus?.DESTINY)
                }
                disabled={
                  !watch("destinyState") ||
                  options?.destinycitiesOptions.length === 0 ||
                  ![addressEnum.OWN, addressEnum.OTHER, ""].includes(
                    watch("destinyLocationStatus")
                  )
                }
              />
              {/* <Input
                bootstrap={'col-12'}
                label={'Dirección (Destino) *'}
                type={'textarea'}
                name={'destinyAddress'}
                placeholder={''}
                register={register}
                errors={errors?.destinyAddress?.message}
                onChange={e =>
                  onChange?.forceRecalulateDistance(e, addressStatus?.DESTINY)
                }
                // disabled={
                //   ![addressEnum.OWN, addressEnum.OTHER, ''].includes(
                //     watch('destinyLocationStatus')
                //   )
                // }
                disabled={true}
              /> */}
              <div className={`input-component-container col-12`}>
                <label htmlFor={"destinyRef"}>Dirección (Destino) *</label>
              </div>
              <PlacesAutocomplete restrictions={{ country: "ve" }} language={"es"}>
                <input
                  id="destinyRef"
                  className="input-map"
                  placeholder="Calle, Avenida, residencia o local"
                  ref={suggestion?.destinyRef}
                  style={{ fontSize: "12px", margin: "0px" }}
                  onClick={() =>
                    onChange.updateLocationStatus(referenceLocation?.DESTINY)
                  }
                  onSelect={() =>
                    onChange.updateLocationStatus(referenceLocation?.DESTINY)
                  }
                />
              </PlacesAutocomplete>
              <Input
                bootstrap={"col-12"}
                label={"Punto de referencia (Destino)"}
                type={"textarea"}
                name={"destinyReferencePoint"}
                placeholder={""}
                register={register}
                errors={errors?.destinyReferencePoint?.message}
              />{" "}
              <Input
                bootstrap={"col-12"}
                label={"Link de Ubicacion (Destino)"}
                type={"text"}
                name={"destinyLocationLink"}
                placeholder={""}
                register={register}
                errors={errors?.destinyLocationLink?.message}
              />{" "}
              <div className="buttons-center-container">
                {/* <AltButton label={'Ajustar ubicación'} /> */}
                <AltButton label={"Calcular distancia"} action={openMapModal} />
              </div>
              <Input
                bootstrap={"col-12"}
                label={"Distancia de origen a destino (Km)*"}
                type={"number"}
                name={"caseKm"}
                placeholder={""}
                register={register}
                min={1}
                errors={errors?.caseKm?.message}
                disabled={true}
              />
            </div>
          </div>
        )}

        {watch("thirdPartyService") && (
          <>
            <div className="buttons-container">
              <div>
                <h6>DATOS DEL VEHÍCULO DEL TERCERO</h6>
              </div>
            </div>
            <Input
              bootstrap={"col-4"}
              label={"Nombre *"}
              type={"text"}
              name={"thirdPartyParticularCustomerName"}
              placeholder={""}
              register={register}
              errors={errors?.thirdPartyParticularCustomerName?.message}
            />
            <Input
              bootstrap={"col-4"}
              label={"Apellido *"}
              type={"text"}
              name={"thirdPartyParticularCustomerLastName"}
              placeholder={""}
              register={register}
              min={1}
              errors={errors?.thirdPartyParticularCustomerLastName?.message}
            />
            <Input
              bootstrap={"col-1"}
              label={"Teléfono *"}
              type={"select"}
              options={phoneCodes}
              name={"thirdPartyServicePhonePrefix"}
              placeholder={""}
              register={register}
              errors={errors?.thirdPartyServicePhonePrefix?.message}
            />{" "}
            <Input
              bootstrap={"col-3"}
              label={""}
              type={"number"}
              name={"thirdPartyServicePhoneNumber"}
              placeholder={""}
              register={register}
              errors={errors?.thirdPartyServicePhoneNumber?.message}
            />
            <Input
              bootstrap={"col-2"}
              label={"Marca del Vehiculo *"}
              type={"select"}
              options={options?.vehicleBrandOptions}
              name={"thirdPartyVehicleBrand"}
              placeholder={""}
              register={register}
              errors={errors?.thirdPartyVehicleBrand?.message}
              onChange={() =>
                onChange?.getVehicleModels(watch("thirdPartyVehicleBrand"))
              }
            />
            <Input
              bootstrap={"col-2"}
              label={"Modelo del Vehiculo *"}
              type={"select"}
              name={"thirdPartyVehicleModel"}
              options={options?.vehicleModelOptions}
              placeholder={""}
              register={register}
              errors={errors?.thirdPartyVehicleModel?.message}
            />{" "}
            <Input
              bootstrap={"col-2"}
              label={"Color del Vehiculo *"}
              type={"text"}
              name={"thirdPartyVehicleColor"}
              placeholder={""}
              register={register}
              errors={errors?.thirdPartyVehicleColor?.message}
            />{" "}
            <Input
              bootstrap={"col-2"}
              label={"Año *"}
              type={"number"}
              name={"thirdPartyVehicleYear"}
              placeholder={""}
              register={register}
              errors={errors?.thirdPartyVehicleYear?.message}
              min={1969}
            />{" "}
            <Input
              bootstrap={"col-2"}
              label={"Placa *"}
              type={"text"}
              name={"thirdPartyVehiclePlate"}
              placeholder={""}
              register={register}
              errors={errors?.thirdPartyVehiclePlate?.message}
            />
          </>
        )}
        <div
          className="buttons-center-container"
          style={{ margin: "0px 0px 48px 0px" }}
        >
          <AltButton label={"Guardar"} action={handleSubmit} />
        </div>
      </div>
    </>
  );
};

export const EditParticularCaseForm = (props) => {
  const {
    register,
    handleSubmit,
    errors,
    onChange,
    options,
    watch,
    openMapModal,
    disabled,
    clientSearch,
    clientType,
    suggestion,
    control,
    lockWithOutDestinyAddress,
  } = props;

  return (
    <>
      {(clientType === clientTypes.ALLY ||
        clientSearch?.selected?.papClient) && (
          <div className="row">
            {forms
              .CreateParticularCustomertForm(
                "",
                register,
                errors,
                options,
                onChange,
                watch,
                control
              )
              .map((l, i) => (
                <Input
                  key={i}
                  title={l?.title}
                  bootstrap={l?.bootstrap}
                  label={l?.label}
                  type={l?.type}
                  name={l?.name}
                  register={l?.register}
                  control={l?.control || control}
                  placeholder={l?.placeholder}
                  errors={l?.errors}
                  data={l}
                  disabled={l?.disabled}
                  numpadForMobile={true}
                />
              ))}
          </div>
        )}

      <div className="row">
        <div className="col-12 col-md-4">
          <div className="row">
            <Input
              bootstrap={"col-5"}
              label={"Dirección de origen*"}
              type={"select"}
              options={options?.addressOption}
              name={"originLocationStatus"}
              placeholder={"Seleccione"}
              register={register}
              errors={errors?.originLocationStatus?.message}
              onChange={(e) =>
                onChange?.selectGarage(e, referenceLocation?.ORIGIN)
              }
            />

            <Input
              bootstrap={"col-4"}
              label={"Ubicacion*"}
              type={"select"}
              options={locationOptions}
              name={"isOriginBasement"}
              placeholder={"Seleccione"}
              register={register}
              errors={errors?.isOriginBasement?.message}
              disabled={
                ![addressEnum.OWN, addressEnum.OTHER, ""].includes(
                  watch("originLocationStatus")
                )
              }
            />
            {[addressEnum.OWN, addressEnum.OTHER].includes(
              watch("originLocationStatus")
            ) && watch("isOriginBasement") === "true" ? (
              <Input
                bootstrap={"col-3"}
                label={"Nivel *"}
                type={"number"}
                name={"basementLevel"}
                placeholder={""}
                register={register}
                min={1}
                errors={errors?.basementLevel?.message}
              />
            ) : null}
          </div>
          <Input
            bootstrap={"col-12"}
            label={"Estado (Origen)*"}
            type={"select"}
            options={options?.statesOptions}
            name={"originState"}
            placeholder={"Seleccione"}
            register={register}
            errors={errors?.originState?.message}
            onChange={(e) => onChange?.getCities(e, referenceLocation?.ORIGIN)}
            disabled={
              ![addressEnum.OWN, addressEnum.OTHER, ""].includes(
                watch("originLocationStatus")
              )
            }
          />
          <Input
            bootstrap={"col-12"}
            label={"Ciudad (Origen)*"}
            type={"select"}
            options={options?.originCitiesOptions}
            name={"originCity"}
            placeholder={"Seleccione"}
            register={register}
            errors={errors?.originCity?.message}
            onChange={(e) => onChange?.forceRecalulateDistance(e)}
            disabled={
              !watch("originState") ||
              options?.originCitiesOptions.length === 0 ||
              ![addressEnum.OWN, addressEnum.OTHER, ""].includes(
                watch("originLocationStatus")
              )
            }
          />
          <div className={`input-component-container col-12`}>
            <label htmlFor={"originRef"}>Dirección (Origen) *</label>
          </div>
          <PlacesAutocomplete restrictions={{ country: "ve" }}>
            <input
              id="originRef"
              className="input-map"
              placeholder="Calle, Avenida, residencia o local"
              ref={suggestion?.originRef}
              style={{ fontSize: "12px", margin: "0px" }}
              onClick={() =>
                onChange.updateLocationStatus(referenceLocation?.ORIGIN)
              }
              onSelect={() =>
                onChange.updateLocationStatus(referenceLocation?.ORIGIN)
              }
            />
          </PlacesAutocomplete>
          <Input
            bootstrap={"col-12"}
            label={"Punto de referencia (Origen)"}
            type={"textarea"}
            name={"originReferencePoint"}
            placeholder={""}
            register={register}
            errors={errors?.originReferencePoint?.message}
          />{" "}
          <Input
            bootstrap={"col-12"}
            label={"Link de Ubicacion (Origen)"}
            type={"text"}
            name={"originLocationLink"}
            placeholder={""}
            register={register}
            errors={errors?.originLocationLink?.message}
          />{" "}
        </div>
        <div className="col-12 col-md-4">
          <div className="row">
            <Input
              bootstrap={"col-12"}
              label={"Teléfono *"}
              type={"phone"}
              name={"contactPhone"}
              control={control}
              register={register}
              placeholder={""}
              errors={errors?.contactPhone?.message}
              numpadForMobile={true}
            />
            <Input
              bootstrap={"col-12"}
              label={"Avería reportada *"}
              type={"select"}
              options={options?.faultsOptions}
              name={"customerFailureReason"}
              placeholder={""}
              register={register}
              errors={errors?.customerFailureReason?.message}
              disabled={disabled || watch("segViaje")}
            />
            <Input
              bootstrap={"col-12"}
              label={"Comentario adicional (Avería)"}
              type={"textarea"}
              name={"customerFailureDescription"}
              placeholder={""}
              register={register}
              errors={errors?.customerFailureDescription?.message}
            />
            {!watch("segViaje") && (
              <Input
                bootstrap={"col-12"}
                subLabel="Sin dirección destino"
                type={"checkbox"}
                name={"withOutDestinyAddress"}
                placeholder={""}
                register={register}
                errors={errors?.withOutDestinyAddress?.message}
                onChange={onChange?.clearDestinyData}
                disabled={
                  clientSearch?.selected?.papClient || lockWithOutDestinyAddress
                    ? true
                    : watch("usualRoute")
                }
              />
            )}
            {clientSearch?.selected?.hasThirdPartyServiceAvailable &&
              !watch("segViaje") && (
                <Input
                  bootstrap={"col-12"}
                  subLabel="Servicio de AV extendido"
                  type={"checkbox"}
                  name={"thirdPartyService"}
                  placeholder={""}
                  register={register}
                  errors={errors?.thirdPartyService?.message}
                  onChange={onChange?.clearThirdPartyData}
                  disabled={watch("usualRoute")}
                />
              )}
            {clientSearch?.selected?.code?.code === membershipCodes?.GOLD &&
              !watch("thirdPartyService") && (
                <Input
                  bootstrap={"col-12"}
                  subLabel="Seguimiento en viaje"
                  type={"checkbox"}
                  name={"segViaje"}
                  placeholder={""}
                  register={register}
                  errors={errors?.segViaje?.message}
                  onChange={onChange?.handleSegViaje}
                  disabled={true}
                />
              )}
            {clientSearch?.selected?.code?.code === membershipCodes?.GOLD &&
              !watch("thirdPartyService") && (
                <Input
                  bootstrap={"col-12"}
                  subLabel="Domicilio-Taller"
                  type={"checkbox"}
                  name={"usualRoute"}
                  placeholder={""}
                  register={register}
                  errors={errors?.usualRoute?.message}
                  disabled={
                    watch("thirdPartyService") ||
                    watch("segViaje") ||
                    watch("withOutDestinyAddress")
                  }
                />
              )}
          </div>
        </div>
        {!watch("withOutDestinyAddress") && (
          <div className="col-12 col-md-4">
            <div className="row">
              <Input
                bootstrap={"col-12"}
                label={"Dirección de Destino *"}
                type={"select"}
                options={options?.addressOption}
                name={"destinyLocationStatus"}
                placeholder={"Seleccione"}
                register={register}
                errors={errors?.destinyLocationStatus?.message}
                onChange={(e) =>
                  onChange?.selectGarage(e, referenceLocation?.DESTINY)
                }
              />
              <Input
                bootstrap={"col-12"}
                label={"Estado (Destino)*"}
                type={"select"}
                options={options?.statesOptions}
                name={"destinyState"}
                placeholder={"Seleccione"}
                register={register}
                errors={errors?.destinyState?.message}
                onChange={(e) =>
                  onChange?.getCities(e, referenceLocation?.DESTINY)
                }
                disabled={
                  ![addressEnum.OWN, addressEnum.OTHER, ""].includes(
                    watch("destinyLocationStatus")
                  )
                }
              />
              <Input
                bootstrap={"col-12"}
                label={"Ciudad (Destino)*"}
                type={"select"}
                options={options?.destinycitiesOptions}
                name={"destinyCity"}
                placeholder={"Seleccione"}
                register={register}
                errors={errors?.destinyCity?.message}
                onChange={(e) => onChange?.forceRecalulateDistance(e)}
                disabled={
                  !watch("destinyState") ||
                  options?.destinycitiesOptions.length === 0 ||
                  ![addressEnum.OWN, addressEnum.OTHER, ""].includes(
                    watch("destinyLocationStatus")
                  )
                }
              />
              <div className={`input-component-container col-12`}>
                <label htmlFor={"destinyRef"}>Dirección (Destino) *</label>
              </div>
              <PlacesAutocomplete restrictions={{ country: "ve" }}>
                <input
                  id="destinyRef"
                  className="input-map"
                  placeholder="Calle, Avenida, residencia o local"
                  ref={suggestion?.destinyRef}
                  style={{ fontSize: "12px", margin: "0px" }}
                  onClick={() =>
                    onChange.updateLocationStatus(referenceLocation?.DESTINY)
                  }
                  onSelect={() =>
                    onChange.updateLocationStatus(referenceLocation?.DESTINY)
                  }
                />
              </PlacesAutocomplete>
              <Input
                bootstrap={"col-12"}
                label={"Punto de referencia (Destino)"}
                type={"textarea"}
                name={"destinyReferencePoint"}
                placeholder={""}
                register={register}
                errors={errors?.destinyReferencePoint?.message}
              />{" "}
              <Input
                bootstrap={"col-12"}
                label={"Link de Ubicacion (Destino)"}
                type={"text"}
                name={"destinyLocationLink"}
                placeholder={""}
                register={register}
                errors={errors?.destinyLocationLink?.message}
              />{" "}
              <div className="buttons-center-container">
                {/* <AltButton label={'Ajustar ubicación'} /> */}
                <AltButton label={"Calcular distancia"} action={openMapModal} />
              </div>
              <Input
                bootstrap={"col-12"}
                label={"Distancia de origen a destino (Km)*"}
                type={"number"}
                name={"caseKm"}
                placeholder={""}
                register={register}
                min={1}
                errors={errors?.caseKm?.message}
                disabled={true}
              />
            </div>
          </div>
        )}
        {watch("thirdPartyService") && (
          <>
            <div className="buttons-container">
              <div>
                <h6>DATOS DEL VEHÍCULO DEL TERCERO</h6>
              </div>
            </div>
            <Input
              bootstrap={"col-4"}
              label={"Nombre *"}
              type={"text"}
              name={"thirdPartyParticularCustomerName"}
              placeholder={""}
              register={register}
              errors={errors?.thirdPartyParticularCustomerName?.message}
            />
            <Input
              bootstrap={"col-4"}
              label={"Apellido *"}
              type={"text"}
              name={"thirdPartyParticularCustomerLastName"}
              placeholder={""}
              register={register}
              min={1}
              errors={errors?.thirdPartyParticularCustomerLastName?.message}
            />
            <Input
              bootstrap={"col-1"}
              label={"Teléfono *"}
              type={"select"}
              options={phoneCodes}
              name={"thirdPartyServicePhonePrefix"}
              placeholder={""}
              register={register}
              errors={errors?.thirdPartyServicePhonePrefix?.message}
            />{" "}
            <Input
              bootstrap={"col-3"}
              label={""}
              type={"number"}
              name={"thirdPartyServicePhoneNumber"}
              placeholder={""}
              register={register}
              errors={errors?.thirdPartyServicePhoneNumber?.message}
            />
            <Input
              bootstrap={"col-2"}
              label={"Marca del Vehiculo *"}
              type={"select"}
              options={options?.vehicleBrandOptions}
              name={"thirdPartyVehicleBrand"}
              placeholder={""}
              register={register}
              errors={errors?.thirdPartyVehicleBrand?.message}
              onChange={() =>
                onChange?.handleModelOptsions(watch("thirdPartyVehicleBrand"))
              }
            />
            <Input
              bootstrap={"col-2"}
              label={"Modelo del Vehiculo *"}
              type={"select"}
              name={"thirdPartyVehicleModel"}
              options={options?.vehicleModelOptions}
              placeholder={""}
              register={register}
              errors={errors?.thirdPartyVehicleModel?.message}
            />{" "}
            <Input
              bootstrap={"col-2"}
              label={"Color del Vehiculo *"}
              type={"text"}
              name={"thirdPartyVehicleColor"}
              placeholder={""}
              register={register}
              errors={errors?.thirdPartyVehicleColor?.message}
            />{" "}
            <Input
              bootstrap={"col-2"}
              label={"Año *"}
              type={"number"}
              name={"thirdPartyVehicleYear"}
              placeholder={""}
              register={register}
              errors={errors?.thirdPartyVehicleYear?.message}
              min={1969}
            />{" "}
            <Input
              bootstrap={"col-2"}
              label={"Placa *"}
              type={"text"}
              name={"thirdPartyVehiclePlate"}
              placeholder={""}
              register={register}
              errors={errors?.thirdPartyVehiclePlate?.message}
            />
          </>
        )}
        <div
          className="buttons-center-container"
          style={{ margin: "0px 0px 48px 0px" }}
        >
          <AltButton label={"Editar"} action={handleSubmit} />
        </div>
      </div>
    </>
  );
};

export const CreateSalesUserForm = (props) => {
  const { register, errors, action, cancel, options, onChange, watch } = props;

  return (
    <form className="form-container">
      <div className="row">
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Nombre*"}
          type={"text"}
          name={"firstName"}
          register={register}
          placeholder={""}
          errors={errors?.firstName?.message}
        />
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Apellido *"}
          type={"text"}
          name={"lastName"}
          register={register}
          placeholder={""}
          errors={errors?.lastName?.message}
        />
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Cedula*"}
          type={"number"}
          name={"identification"}
          register={register}
          placeholder={""}
          errors={errors?.identification?.message}
        />
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Email *"}
          type={"text"}
          name={"email"}
          register={register}
          placeholder={""}
          errors={errors?.email?.message}
        />
        <div className="col-md-6"></div>
        <div className="col-12 col-md-6">
          <p>
            La contraseña debe:
            <li style={{ fontSize: "12px" }}>
              Tener un <b>minimo de 8 caracteres</b>
            </li>
            <li style={{ fontSize: "12px" }}>
              Tener <b>1 mayuscula</b>
            </li>
            <li style={{ fontSize: "12px" }}>
              Tener un <b>2 numeros</b>
            </li>
            <li style={{ fontSize: "12px" }}>
              Tener un <b>1 caracter especial</b>
            </li>
          </p>
        </div>
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Contraseña *"}
          type={"password"}
          name={"password"}
          register={register}
          placeholder={""}
          errors={errors?.password?.message}
        />
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Confirmar contraseña *"}
          type={"password"}
          name={"confirmPassword"}
          register={register}
          placeholder={""}
          errors={errors?.confirmPassword?.message}
        />
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Modulo *"}
          type={"select"}
          name={"module"}
          options={options?.modulesOptions}
          register={register}
          placeholder={""}
          errors={errors?.module?.message}
          onChange={onChange?.getRoles}
          disabled={true}
        />{" "}
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Rol *"}
          type={"select"}
          options={options?.rolesOptions}
          name={"role"}
          register={register}
          placeholder={""}
          errors={errors?.role?.message}
          disabled={options?.rolesOptions.length <= 0}
          onChange={onChange?.getProviders}
        />
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Estatus *"}
          type={"select"}
          name={"status"}
          options={options?.userStatusOptions}
          register={register}
          placeholder={""}
          errors={errors?.status?.message}
        />
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Turno *"}
          type={"select"}
          options={options?.shiftOptions}
          name={"shift"}
          register={register}
          placeholder={""}
          errors={errors?.shift?.message}
          capitalizeOff={true}
        />
        {watch("role") === salesRoles?.SALES_COUNTER && (
          <Input
            bootstrap={"col-12 col-md-6"}
            label={"Tipo *"}
            type={"select"}
            name={"type"}
            options={options?.userTypeOptions}
            register={register}
            placeholder={""}
            errors={errors?.type?.message}
          />
        )}
        {[
          operationsRoles?.OPERATIONS_FLOTA_AV,
          operationsRoles?.OPERATIONS_FLOTA_GRUA,
          operationsRoles?.OPERATIONS_FLOTA_GRUA_EXT,
        ]?.includes(watch("role")) && (
            <Input
              bootstrap={"col-12 col-md-6"}
              label={"Proveedor *"}
              type={"select"}
              name={"provider"}
              options={options?.providersOptions}
              register={register}
              placeholder={""}
              errors={errors?.provider?.message}
            />
          )}
      </div>

      <div className="buttons-center-container">
        {/* <h6>¿ Esta seguro que desea cancelar el servicio ?</h6> */}
      </div>
      <div className="buttons-center-container">
        <AltButton action={cancel} label={"No"} />
        <ActionButton action={action} label={"Si"} />
      </div>
    </form>
  );
};

export const CreateAllyForm = (props) => {
  const { register, errors, action, cancel, options, watch, setValue } =
    props.modal.form;

  return (
    <form className="form-container">
      <div className="row">
        {watch("isNew") ? (
          <Input
            bootstrap={"col-12"}
            label={"Registrar nueva empresa *"}
            type={"text"}
            name={"newEnterprise"}
            register={register}
            placeholder={""}
            errors={errors?.newEnterprise?.message}
          />
        ) : (
          <Input
            bootstrap={"col-12"}
            label={"Empresa *"}
            type={"select"}
            name={"enterprise"}
            options={options?.enterpriseOptions}
            register={register}
            placeholder={""}
            errors={errors?.enterprise?.message}
          />
        )}
        <div className="col-12">
          {watch("isNew") ? (
            <h6
              onClick={() => setValue("isNew", false)}
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              Utilizar Empresa existente
            </h6>
          ) : (
            <h6
              onClick={() => setValue("isNew", true)}
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              Registrar Nueva empresa
            </h6>
          )}
        </div>
        <Input
          bootstrap={"col-6"}
          label={"Nombre *"}
          type={"text"}
          name={"firstName"}
          register={register}
          placeholder={""}
          errors={errors?.firstName?.message}
        />
        <Input
          bootstrap={"col-6"}
          label={"Apellido *"}
          type={"text"}
          name={"lastName"}
          register={register}
          placeholder={""}
          errors={errors?.lastName?.message}
        />
        <Input
          bootstrap={"col-4 "}
          label={"C.I / RIF*"}
          type={"select"}
          name={"identificationType"}
          register={register}
          placeholder={""}
          options={idCodes}
          errors={errors?.identificationType?.message}
        // onChange={() => setValue('identification', '')}
        />{" "}
        <Input
          bootstrap={"col-8"}
          label={"Cédula*"}
          type={"number"}
          name={"identification"}
          register={register}
          placeholder={""}
          errors={errors?.identification?.message}
        />
        <Input
          bootstrap={"col-12"}
          label={"Status*"}
          type={"select"}
          options={options?.allyStatusOptions}
          name={"status"}
          register={register}
          placeholder={""}
          errors={errors?.status?.message}
        />
        <Input
          bootstrap={"col-6"}
          subLabel="Servicio AV Disponible"
          type={"checkbox"}
          name={"hasAvService"}
          placeholder={""}
          register={register}
          errors={errors?.hasAvService?.message}
        />
        <Input
          bootstrap={"col-6"}
          subLabel="Servicio AV gratis"
          type={"checkbox"}
          name={"freeAvService"}
          placeholder={""}
          register={register}
          errors={errors?.freeAvService?.message}
        />
      </div>

      <div className="buttons-center-container">
        {/* <h6>¿ Esta seguro que desea cancelar el servicio ?</h6> */}
      </div>
      <div className="buttons-center-container">
        <AltButton action={cancel} label={"Cancelar"} />
        <ActionButton action={action} label={"Crear"} />
      </div>
    </form>
  );
};

export const BlockAllyForm = (props) => {
  const { cancel, action } = props;

  return (
    <div className="buttons-center-container">
      <AltButton action={cancel} label={"Cancelar"} />
      <ActionButton action={action} label={"Continuar"} />
    </div>
  );
};

export const EditSalesUserForm = (props) => {
  const { register, errors, action, cancel, options } = props;

  return (
    <form className="form-container">
      <div className="row">
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Nombre*"}
          type={"text"}
          name={"firstName"}
          register={register}
          placeholder={""}
          errors={errors?.firstName?.message}
        />
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Apellido *"}
          type={"text"}
          name={"lastName"}
          register={register}
          placeholder={""}
          errors={errors?.lastName?.message}
        />
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Cedula*"}
          type={"number"}
          name={"identification"}
          register={register}
          placeholder={""}
          errors={errors?.identification?.message}
        />
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Email *"}
          type={"text"}
          name={"email"}
          register={register}
          placeholder={""}
          errors={errors?.email?.message}
        />
        <div className="col-md-6"></div>
        <div className="col-12 col-md-6">
          <p>
            La contraseña debe:
            <li style={{ fontSize: "12px" }}>
              Tener un <b>minimo de 8 caracteres</b>
            </li>
            <li style={{ fontSize: "12px" }}>
              Tener <b>1 mayuscula</b>
            </li>
            <li style={{ fontSize: "12px" }}>
              Tener un <b>2 numeros</b>
            </li>
            <li style={{ fontSize: "12px" }}>
              Tener un <b>1 caracter especial</b>
            </li>
          </p>
        </div>
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Contraseña *"}
          type={"password"}
          name={"password"}
          register={register}
          placeholder={""}
          errors={errors?.password?.message}
        />
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Confirmar contraseña *"}
          type={"password"}
          name={"confirmPassword"}
          register={register}
          placeholder={""}
          errors={errors?.confirmPassword?.message}
        />
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Estatus *"}
          type={"select"}
          name={"status"}
          options={options?.userStatusOptions}
          register={register}
          placeholder={""}
          errors={errors?.status?.message}
        />
        <Input
          bootstrap={"col-12 col-md-6"}
          label={"Turno *"}
          type={"select"}
          options={options?.shiftOptions}
          name={"shift"}
          register={register}
          placeholder={""}
          errors={errors?.shift?.message}
          capitalizeOff={true}
        />
      </div>

      <div className="buttons-center-container">
        {/* <h6>¿ Esta seguro que desea cancelar el servicio ?</h6> */}
      </div>
      <div className="buttons-center-container">
        <AltButton action={cancel} label={"No"} />
        <ActionButton action={action} label={"Si"} />
      </div>
    </form>
  );
};

const LOCKSMITH_PAGO_MOVIL_FIELDS = ["locksmithPhone", "locksmithIdType", "locksmithId"];
const LOCKSMITH_TRANSFER_FIELDS = ["locksmithAccount", "locksmithFullName"];
const LOCKSMITH_INVOICE_TYPES = ["image/jpeg", "image/png"];

// Reemplaza "Agregar IVA" en el modal de pago de cerrajeria
export const LocksmithInvoiceSection = (props) => {
  const { register, errors, watch, setValue } = props;

  useEffect(() => {
    register("locksmithInvoice");
    register("hasLocksmithInvoiceFile");
  }, [register]);

  const clearFields = (fields) =>
    fields.forEach((field) => setValue(field, ""));

  const handleWithInvoice = (e) => {
    if (!e?.target?.checked) {
      clearFields([
        "locksmithPayMethod",
        "locksmithBank",
        ...LOCKSMITH_PAGO_MOVIL_FIELDS,
        ...LOCKSMITH_TRANSFER_FIELDS,
      ]);
      setValue("locksmithInvoice", undefined);
    }
  };

  const handlePayMethod = (e) => {
    clearFields(
      e?.target?.value === locksmithPayMethods.PAGO_MOVIL
        ? LOCKSMITH_TRANSFER_FIELDS
        : LOCKSMITH_PAGO_MOVIL_FIELDS
    );
  };

  const handleInvoiceDrop = (e) => {
    e?.preventDefault?.();
    if (e?.type === "dragover") return;
    const file = e?.dataTransfer?.files?.[0] || e?.target?.files?.[0];
    if (!file) return;
    if (!LOCKSMITH_INVOICE_TYPES.includes(file.type)) {
      notify("Solo se permiten imágenes JPG o PNG", "info");
      return;
    }
    setValue("locksmithInvoice", file, { shouldValidate: true });
  };

  const payMethod = watch("locksmithPayMethod");

  return (
    <>
      <Input
        bootstrap={"col-12"}
        subLabel="Agregar factura del cliente"
        type={"checkbox"}
        name={"withInvoice"}
        register={register}
        errors={errors?.withInvoice?.message}
        onChange={handleWithInvoice}
      />
      {watch("withInvoice") && (
        <div className="col-12 row">
          <div className="col-12">
            <FileDropzone
              instructions={
                watch("hasLocksmithInvoiceFile")
                  ? "Imagen de la factura (ya cargada, adjunte otra para reemplazarla)"
                  : "Imagen de la factura *"
              }
              maxWeight={"Formatos permitidos: JPG, PNG"}
              accept={"image/jpeg,image/png"}
              name={"locksmithInvoice"}
              index={0}
              file={watch("locksmithInvoice")}
              handleDrop={handleInvoiceDrop}
              removeFile={() => setValue("locksmithInvoice", undefined)}
              error={!!errors?.locksmithInvoice}
            />
            <p className="error-message">{errors?.locksmithInvoice?.message}</p>
          </div>
          <div className="col-12 light-gray-line"></div>
          <h6 className="col-12">Datos de pago del cliente</h6>
          <Input
            bootstrap={"col-4"}
            label={"Método de pago *"}
            type={"select"}
            options={locksmithPayMethodOptions}
            name={"locksmithPayMethod"}
            register={register}
            errors={errors?.locksmithPayMethod?.message}
            onChange={handlePayMethod}
          />
          <div className="col-8"></div>
          {payMethod === locksmithPayMethods.PAGO_MOVIL && (
            <>
              <Input
                bootstrap={"col-3"}
                label={"Teléfono *"}
                type={"text"}
                name={"locksmithPhone"}
                register={register}
                placeholder={"04XX-XXXXXXX"}
                errors={errors?.locksmithPhone?.message}
              />
              <Input
                bootstrap={"col-1"}
                label={"Cédula *"}
                type={"select"}
                options={locksmithIdCodes}
                name={"locksmithIdType"}
                register={register}
                errors={errors?.locksmithIdType?.message}
              />
              <Input
                bootstrap={"col-3"}
                label={"\u00a0"}
                type={"text"}
                name={"locksmithId"}
                register={register}
                placeholder={"12345678"}
                errors={errors?.locksmithId?.message}
              />
              <Input
                bootstrap={"col-5"}
                label={"Banco *"}
                type={"select"}
                options={banksOptions}
                name={"locksmithBank"}
                register={register}
                errors={errors?.locksmithBank?.message}
              />
            </>
          )}
          {payMethod === locksmithPayMethods.TRANSFERENCIA && (
            <>
              <Input
                bootstrap={"col-5"}
                label={"Número de cuenta *"}
                type={"text"}
                name={"locksmithAccount"}
                register={register}
                placeholder={"0000-0000-00-0000000000"}
                errors={errors?.locksmithAccount?.message}
              />
              <Input
                bootstrap={"col-4"}
                label={"Banco *"}
                type={"select"}
                options={banksOptions}
                name={"locksmithBank"}
                register={register}
                errors={errors?.locksmithBank?.message}
              />
              <Input
                bootstrap={"col-3"}
                label={"Nombre y Apellido *"}
                type={"text"}
                name={"locksmithFullName"}
                register={register}
                placeholder={"Nombre y apellido"}
                errors={errors?.locksmithFullName?.message}
              />
            </>
          )}
        </div>
      )}
    </>
  );
};

export const CreateAVForm = (props) => {
  const {
    register,
    options,
    errors,
    cancel,
    action,
    watch,
    onChange,
    fileUploaded,
    setFileUploaded,
    bsDisabled,
    handleDrop,
    cashBackImage,
    removeFile,
    errorsDropzone,
    battery,
    setValue,
    showErrorAPI,
  } = props;

  const paymentMethods = (metodo) => {
    let array = [];
    for (let i = 0; i < parseInt(watch("paymentMethods")); i++) {
      array.push({
        name: "method" + i,
        label: `Metodo ${i + 1} *`,
        type: "select",
        bootstrap: "col-3",
        errors: errors?.[`method` + i]?.message,
        index: i,
      });

      array.push({
        dropzone: "a",
        label: `Comprobante ${i + 1} *`,
        index: i,
      });


      let method = filterOptionById(
        options?.paymentMethods,
        watch("method" + i)
      );
      if ([metodosDePago.ZELLE, metodosDePago.PAYPAL].includes(method?.name)) {
        array.push({
          name: "accHolder" + i,
          label: `Titular ${i + 1} *`,
          type: "text",
          bootstrap: "col-3",
          errors: errors?.[`accHolder` + i]?.message,
        });
      }

      if (metodo._id === watch("method0") && i === 0) {
        array.push({
          name: "paid",
          label: `Monto Ingresado *`,
          type: "number",
          bootstrap: "col-3",
          errors: errors?.[`paid`]?.message,
        });
      }

      array.push({
        name: "amount" + i,
        label: `Monto ${i + 1} (USD) *`,
        type: "number",
        bootstrap: "col-3",
        errors: errors?.[`amount` + i]?.message,
      });
      array.push({
        name: "amountBsS" + i,
        label: `Monto ${i + 1} (Bs)*`,
        type: "number",
        bootstrap: "col-3",
        errors: errors?.[`amountBsS` + i]?.message,
        disabled: bsDisabled,
      });

      if (
        [
          metodosDePago?.CASH_USD,
          metodosDePago?.CASH_BS,
          metodosDePago?.CASH_EUR,
        ].includes(
          filterOptionById(options?.paymentMethods, watch(`method${i}`)).name
        )
      ) {
        array.push({
          name: "cashReceiver" + i,
          label: `Caja de venta ${i + 1} *`,
          type: "select",
          bootstrap: "col-3",
          errors: errors?.[`cashReceiver` + i]?.message,
          options: options.cashReceiverOptions,
        });
      }

      array.push({
        name: "reference" + i,
        label: `Referencia ${i + 1} *`,
        type: "text",
        bootstrap: "col-3",
        errors: errors?.[`reference` + i]?.message,
        disabled: [metodosDePago.ZELLE, metodosDePago.PAYPAL].includes(
          filterOptionById(options.filteredMethods, watch("method" + i))?.name
        ),
      });
      array.push({
        skipApiValidationError: true,
        index: i,
      });
      array.push({
        // name: 'paymentMethod' + i,
        // label: `Comprobante ${i + 1} *`,
        // type: 'text',
        bootstrap: "col-12",
        // errors: errors?.[`paymentMethod` + i]?.message,
      });
    }
    return array;
  };

  const returnAccountData = (paymentMethods, id) => {
    let [account] = paymentMethods.filter((a) => a._id === id);

    let showInfo = (text, value) => {
      if (value) {
        return text + value + "\n";
      } else return "";
    };

    let data = "";
    data =
      showInfo(``, capitalize(account?.name)) +
      showInfo(`Cuenta: `, account?.details?.account) +
      showInfo(`Banco: `, account?.details?.bank) +
      showInfo(`Numero de Cuenta: `, account?.details?.accountNumber) +
      showInfo(`Numero de Telefono: `, account?.details?.phone) +
      showInfo(`Cedula: `, account?.details?.rif);
    return data;
  };

  return (
    <>
      <div style={{ margin: "0px" }} className="buttons-container">
        <h2 style={{ margin: "0px" }}>Información Adicional</h2>
      </div>
      <p style={{ margin: "0px" }}>(*) Campos obligatorios</p>
      <form style={{ maxWidth: "900px" }} className="form-container">
        <div className="row">
          <Input
            bootstrap={"col-3"}
            label={"Teléfono del Cliente *"}
            type={"text"}
            options={options?.brandOptions}
            name={"contact"}
            register={register}
            placeholder={""}
            errors={errors?.contact?.message}
            disabled={true}
          />
          <Input
            bootstrap={"col-3"}
            label={"Año del Vehículo *"}
            type={"text"}
            name={"vehicleYear"}
            register={register}
            placeholder={""}
            errors={errors?.vehicleYear?.message}
            disabled={true}
          />
          <Input
            bootstrap={"col-3"}
            label={"Marca del Vehiculo *"}
            type={"text"}
            options={options?.brandOptions}
            name={"vehicleBrand"}
            register={register}
            placeholder={""}
            errors={errors?.vehicleBrand?.message}
            disabled={true}
          />{" "}
          <Input
            bootstrap={"col-3"}
            label={"Modelo del Vehiculo *"}
            type={"text"}
            options={options?.brandOptions}
            name={"vehicleModel"}
            register={register}
            placeholder={""}
            errors={errors?.vehicleModel?.message}
            disabled={true}
          />{" "}
          <Input
            bootstrap={"col-3"}
            label={"Placa del Vehículo *"}
            type={"text"}
            options={options?.brandOptions}
            name={"vehiclePlate"}
            register={register}
            placeholder={""}
            errors={errors?.vehiclePlate?.message}
            disabled={true}
          />
          <Input
            bootstrap={"col-3"}
            label={"Color del Vehículo *"}
            type={"text"}
            options={options?.brandOptions}
            name={"vehicleColor"}
            register={register}
            placeholder={""}
            errors={errors?.vehicleColor?.message}
            disabled={true}
          />
          {!watch("isLocksmith") && (
            <Input
              bootstrap={"col-3"}
              label={"Tiempo de Llegada (min) *"}
              type={"text"}
              name={"estimatedTime"}
              register={register}
              placeholder={""}
              errors={errors?.estimatedTime?.message}
              disabled={true}
            />
          )}{" "}
          <Input
            bootstrap={"col-3"}
            label={"Estatus de Pago *"}
            type={"select"}
            options={options?.PaymentStatusOptions}
            name={"paymentStatus"}
            register={register}
            placeholder={""}
            onChange={onChange?.changePaymentStatus}
            errors={errors?.paymentStatus?.message}
          />
          {validateCourtesy(
            watch("paymentStatus"),
            PaymentStatus?.COURTESY
          ) && (
              <Input
                bootstrap={"col-3"}
                label={"Autorizado por *"}
                type={"select"}
                options={options?.authorizedByOptions}
                name={"authorizedBy"}
                register={register}
                placeholder={""}
                errors={errors?.authorizedBy?.message}
              />
            )}

          <Input
            bootstrap={"col-6"}
            label={
              watch("isLocksmith")
                ? "Costo del servicio USD"
                : "Costo del servicio USD *"
            }
            type={"number"}
            options={options?.brandOptions}
            name={"price"}
            register={register}
            placeholder={""}
            errors={errors?.price?.message}
            disabled={battery}
            min={"0"}
          />
          <Input
            bootstrap={"col-6"}
            label={"Monto que paga el cliente USD *"}
            type={"number"}
            name={"pvp"}
            register={register}
            placeholder={""}
            errors={errors?.pvp?.message}
            min={"0"}
            onChange={() => {
              onChange?.handleAddIva(null, [
                {
                  name: 'pvp',
                  valueToSum: watch("pvp"),
                }
              ], true)
              onChange?.restorePaymentMethods()
            }}
            disabled={
              [PaymentStatus?.N_A, PaymentStatus?.COURTESY].includes(
                watch("paymentStatus")
              ) || battery
            }
          />

          {watch("isLocksmith") ? (
            <LocksmithInvoiceSection
              register={register}
              errors={errors}
              watch={watch}
              setValue={setValue}
            />
          ) : (
            <Input
              bootstrap={"col-12"}
              subLabel="Agregar IVA"
              type={"checkbox"}
              name={"addIva"}
              placeholder={""}
              register={register}
              errors={errors?.addIva?.message}
              onChange={(e) => onChange?.handleAddIva(e, [
                {
                  name: 'pvp',
                  valueToSum: watch("pvp"),
                }
              ])}
            />
          )}

          {
            !watch("isLocksmith") && watch("addIva") && (
              <div className="col-12 row">
                <Input
                  bootstrap={"col-6"}
                  label={"% IVA"}
                  type={"number"}
                  name={"ivaPercentage"}
                  register={register}
                  placeholder={""}
                  errors={errors?.ivaPercentage?.message}
                  min={"0"}
                  disabled
                  defaultValue={16}
                />
                <Input
                  bootstrap={"col-6"}
                  label={"Monto IVA USD"}
                  type={"number"}
                  name={"ivaAmount"}
                  register={register}
                  placeholder={""}
                  errors={errors?.ivaAmount?.message}
                  min={"0"}
                  disabled
                />
              </div>
            )
          }

          {watch("pvp") > 0 &&
            ![PaymentStatus?.N_A, PaymentStatus?.CUENTA_POR_COBRAR].includes(
              watch("paymentStatus")
            ) && (
              <>
                <Input
                  bootstrap={"col-4"}
                  label={"Cantidad de Métodos de Pago"}
                  type={"number"}
                  name={"paymentMethods"}
                  register={register}
                  placeholder={""}
                  errors={errors?.paymentMethods?.message}
                  options={options?.paymentMethods}
                  onChange={onChange?.validateMaxPaymentMethods}
                  min={"1"}
                  max={"5"}
                />
                <div className="col-8"></div>
              </>
            )}
          {watch("paymentMethods") > 0 &&
            watch("pvp") > 0 &&
            ![PaymentStatus?.N_A, PaymentStatus?.CUENTA_POR_COBRAR].includes(
              watch("paymentStatus")
            ) && (
              <>
                {paymentMethods(
                  filterOption(options?.paymentMethods, metodosDePago?.CASH_USD)
                ).map((p, index) => (
                  <PaymentSection
                    key={p?.label || `skipApi-${p?.index}-${index}`}
                    payment={p}
                    watch={watch}
                    options={options}
                    register={register}
                    errors={errors}
                    index={p.index}
                    returnAccountData={returnAccountData}
                    fileUploaded={fileUploaded}
                    setFileUploaded={setFileUploaded}
                    onChange={onChange}
                    setValue={setValue}
                    showErrorAPI={showErrorAPI}
                  />
                ))}
              </>
            )}
          <CashBackComponent
            register={register}
            errors={errors}
            watch={watch}
            options={{
              paymemtMethodOptions: options?.paymentMethods,
              filteredMethods: options?.filteredMethods,
            }}
            onChange={{
              handleCashbackBs: onChange?.handleCashbackBs,
              handleCashbackMethodsQuantity:
                onChange?.handleCashbackMethodsQuantity,
            }}
            handleDrop={handleDrop}
            cashBackImage={cashBackImage}
            removeFile={removeFile}
            errorsDropzone={errorsDropzone}
          />
        </div>
      </form>
      <div className="buttons-center-container">
        <AltButton action={() => cancel()} label={"Cancelar"} />
        <ActionButton action={action} label={"Guardar"} />
      </div>
    </>
  );
};

export const FolloUpTimeComponent = () => { };

export const FollowUpForm = (props) => {
  const {
    register,
    options,
    errors,
    cancel,
    action,
    edit,
    control,
    watch,
    onChange,
    acceptFollowing,
  } = props;

  const followUps = ["", "", "", "", ""];

  return (
    <>
      <div style={{ margin: "0px" }} className="buttons-container">
        <h2 style={{ margin: "0px" }}>Seguimiento en viaje</h2>
      </div>
      <p style={{ margin: "0px" }}>(*) Campos obligatorios</p>
      <form style={{ maxWidth: "900px" }} className="form-container">
        <div className="row">
          <Input
            bootstrap={"col-4"}
            label={"Tiempo estimado (min) *"}
            type={"number"}
            options={options?.brandOptions}
            name={"expectedTime"}
            register={register}
            placeholder={""}
            errors={errors?.expectedTime?.message}
            disabled={true}
          />
          <Input
            bootstrap={"col-4"}
            label={"Fecha del viaje *"}
            type={"date"}
            name={"tripDate"}
            register={register}
            placeholder={""}
            errors={errors?.tripDate?.message}
            control={control}
            onChange={() => onChange?.restartTracking()}
          />
          <Input
            bootstrap={"col-4"}
            label={"Hora de Inicio *"}
            type={"time"}
            name={"contactTime"}
            register={register}
            placeholder={""}
            errors={errors?.contactTime?.message}
            onChange={() => onChange?.restartTracking()}
          />
          <Input
            bootstrap={"col-4"}
            label={"Frecuencia de Seguimientos (min) *"}
            type={"number"}
            options={options?.brandOptions}
            name={"frequency"}
            register={register}
            placeholder={""}
            errors={errors?.frequency?.message}
            onChange={() => onChange?.restartTracking()}
          />
          <Input
            bootstrap={"col-4"}
            label={"Cantidad de Seguimientos *"}
            type={"number"}
            options={options?.brandOptions}
            name={"amount"}
            register={register}
            placeholder={""}
            errors={errors?.amount?.message}
            disabled={true}
          />
          <div className="col-4"></div>

          {followUps?.map((f, index) => {
            if (watch(`tracking${index}`)) {
              return (
                <>
                  <div className="col-4"></div>
                  <Input
                    bootstrap={"col-4"}
                    label={`Hora de Seguimiento ${index + 1} *`}
                    type={"time"}
                    options={options?.brandOptions}
                    name={`tracking${index}`}
                    register={register}
                    placeholder={""}
                    errors={errors?.[`tracking${index}`]?.message}
                    disabled={true}
                  />
                  <div className="col-4"></div>
                </>
              );
            } else return null;
          })}
        </div>
      </form>
      <div className="buttons-center-container">
        <AltButton action={() => cancel()} label={"Cancelar"} />

        {!watch("tracking0") && !watch("created") && (
          <ActionButton action={action} label={"Guardar"} />
        )}

        {!watch("tracking0") && watch("created") && (
          <ActionButton action={edit} label={"Editar"} />
        )}

        {watch("tracking0") && watch("created") && (
          <ActionButton action={acceptFollowing} label={"Aceptar"} />
        )}
      </div>
    </>
  );
};

export const CreatePaymentForm = (props) => {
  const {
    register,
    options,
    errors,
    cancel,
    modal,
    action,
    watch,
    control,
    onChange,
    fileUploaded,
    setFileUploaded,
    bsDisabled,
    handleDrop,
    cashBackImage,
    removeFile,
    errorsDropzone,
    OTP,
    handleEditPayment,
    setValue,
    showErrorAPI,
  } = props;

  const paymentMethods = (metodo) => {
    let array = [];
    for (let i = 0; i < parseInt(watch("paymentMethods")); i++) {
      array.push({
        name: "method" + i,
        label: `Metodo ${i + 1} *`,
        type: "select",
        bootstrap: "col-3",
        errors: errors?.[`method` + i]?.message,
        index: i,
      });

      array.push({
        dropzone: "a",
        label: `Comprobante ${i + 1} *`,
        index: i,
      });

      let method = filterOptionById(
        options?.paymentMethods,
        watch("method" + i)
      );
      if ([metodosDePago.ZELLE, metodosDePago.PAYPAL].includes(method?.name)) {
        array.push({
          name: "accHolder" + i,
          label: `Titular ${i + 1} *`,
          type: "text",
          bootstrap: "col-3",
          errors: errors?.[`accHolder` + i]?.message,
        });
      }

      if (metodo._id === watch("method0") && i === 0) {
        array.push({
          name: "paid",
          label: `Monto Ingresado *`,
          type: "number",
          bootstrap: "col-3",
          errors: errors?.[`paid`]?.message,
        });
      }

      array.push({
        name: "amount" + i,
        label: `Monto ${i + 1} (USD) *`,
        type: "number",
        bootstrap: "col-3",
        errors: errors?.[`amount` + i]?.message,
      });
      array.push({
        name: "amountBsS" + i,
        label: `Monto ${i + 1} (Bs)*`,
        type: "number",
        bootstrap: "col-3",
        errors: errors?.[`amountBsS` + i]?.message,
        disabled: bsDisabled,
      });

      array.push({
        name: "reference" + i,
        label: `Referencia ${i + 1} *`,
        type: "text",
        bootstrap: "col-3",
        errors: errors?.[`reference` + i]?.message,
        disabled: [metodosDePago.ZELLE, metodosDePago.PAYPAL].includes(
          filterOptionById(options.filteredMethods, watch("method" + i))?.name
        ),
      });
      array.push({
        skipApiValidationError: true,
        index: i,
      });
      array.push({
        // name: 'paymentMethod' + i,
        // label: `Comprobante ${i + 1} *`,
        // type: 'text',
        bootstrap: "col-12",
        // errors: errors?.[`paymentMethod` + i]?.message,
      });

      if (
        [
          metodosDePago?.CASH_USD,
          metodosDePago?.CASH_BS,
          metodosDePago?.CASH_EUR,
        ].includes(
          filterOptionById(options?.paymentMethods, watch(`method${i}`)).name
        )
      ) {
        array.push({
          name: "cashReceiver" + i,
          label: `Caja de venta ${i + 1} *`,
          type: "select",
          bootstrap: "col-3",
          errors: errors?.[`cashReceiver` + i]?.message,
          options: options.cashReceiverOptions,
        });
      }
    }
    return array;
  };

  const returnAccountData = (paymentMethods, id) => {
    let [account] = paymentMethods.filter((a) => a._id === id);

    let showInfo = (text, value) => {
      if (value) {
        return text + value + "\n";
      } else return "";
    };

    let data = "";
    data =
      showInfo(``, capitalize(account?.name)) +
      showInfo(`Cuenta: `, account?.details?.account) +
      showInfo(`Banco: `, account?.details?.bank) +
      showInfo(`Numero de Cuenta: `, account?.details?.accountNumber) +
      showInfo(`Numero de Telefono: `, account?.details?.phone) +
      showInfo(`Cedula: `, account?.details?.rif);
    return data;
  };
  return (
    <>
      <div style={{ margin: "0px" }} className="buttons-container">
        <h2 style={{ margin: "0px" }}>Información Adicional</h2>
      </div>
      <p style={{ margin: "0px" }}>(*) Informacion de pago</p>
      <div style={{ maxWidth: "900px" }} className="form-container">
        <div className="row">
          <Input
            bootstrap={"col-3"}
            label={"Servicio *"}
            type={"text"}
            name={"serviceName"}
            register={register}
            placeholder={""}
            errors={errors?.serviceName?.message}
            disabled={true}
          />
          {watch("paid") && (
            <div className="col-12 pending-paiment-success-message">
              <h6>Pago Pendiente Realizado</h6>
            </div>
          )}
          <Input
            bootstrap={"col-3"}
            label={"Estatus de Pago *"}
            type={"select"}
            options={
              [caseType.ALLY, caseType.PARTICULAR].includes(
                modal?.incidence?.caseType
              ) || watch("amountExcess") > 0
                ? options?.PaymentStatusOptions.filter(
                  (b) => b?.name !== PaymentStatus?.N_A
                )
                : options?.PaymentStatusOptions
            }
            name={"paymentStatus"}
            register={register}
            placeholder={""}
            onChange={onChange?.changePaymentStatus}
            errors={errors?.paymentStatus?.message}
            disabled={watch("paymentStatus") === paymentType?.PENDING}
          />
          {validateCourtesy(
            watch("paymentStatus"),
            PaymentStatus?.COURTESY
          ) && (
              <Input
                bootstrap={"col-3"}
                label={"Autorizado por *"}
                type={"select"}
                options={options?.authorizedByOptions}
                name={"authorizedBy"}
                register={register}
                placeholder={""}
                errors={errors?.authorizedBy?.message}
              />
            )}
          <Input
            bootstrap={"col-3"}
            label={
              watch("isLocksmith")
                ? "Costo del servicios USD"
                : "Costo del servicios USD *"
            }
            type={"number"}
            options={options?.brandOptions}
            name={"price"}
            register={register}
            placeholder={""}
            onChange={onChange?.handlePriceChange}
            errors={errors?.price?.message}
            min={"0"}
            disabled={watch("serviceName") === "Venta De Baterias"}
          />
          {![0]?.includes(OTP?.optStatus) && (
            <>
              <Input
                bootstrap={"col-3"}
                label={"Aprobado por *"}
                type={"select"}
                options={options?.authorizedByOptions}
                name={"approvedBy"}
                register={register}
                placeholder={""}
                errors={errors?.approvedBy?.message}
                disabled={[2]?.includes(OTP?.optStatus)}
              />
              <Input
                bootstrap={"col-3"}
                label={"Código *"}
                type={"text"}
                name={"code"}
                register={register}
                placeholder={""}
                errors={errors?.code?.message}
                disabled={[2]?.includes(OTP?.optStatus)}
              />
            </>
          )}

          {[1]?.includes(OTP?.optStatus) && (
            <div className="col-12">
              <div className="row">
                <div className="col-6" style={{ textAlign: "center" }}>
                  {/* <p>Por favor ingrese el código de autorización para poder gestionar el servicio con el costo marcado</p> */}
                  <p>
                    Solicitar el código de autorización para poder gestionar el
                    servicio con el costo marcado
                  </p>
                </div>
                <div className="col-6" style={{ textAlign: "center" }}>
                  <div
                    style={{ marginTop: "18px" }}
                    className="buttons-container"
                  >
                    {!watch("code") ? (
                      <ActionButton
                        label="Solicitar código de autorización "
                        action={() => OTP?.requestOTP()}
                      />
                    ) : (
                      <ActionButton
                        label="Validar código de autorización "
                        action={() => OTP?.validateOTP()}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Cerrajeria: el cliente paga al cerrajero, no hay monto a cobrar */}
          {!watch("isLocksmith") && (
            <Input
              bootstrap={"col-3"}
              label={"Monto que paga el cliente USD *"}
              type={"number"}
              name={"pvp"}
              register={register}
              placeholder={""}
              errors={errors?.pvp?.message}
              min={"0"}
              onChange={() => {
                onChange?.handleAddIva(null, [
                  {
                    name: 'pvp',
                    valueToSum: watch("pvp"),
                  },
                  {
                    name: 'amountExcess',
                    valueToSum: watch("amountExcess"),
                  },
                  {
                    name: 'amountHandling',
                    valueToSum: watch("amountHandling"),
                  },
                ], true)
                onChange?.restorePaymentMethods()
              }}
              disabled={
                [PaymentStatus?.N_A, PaymentStatus?.COURTESY].includes(
                  watch("paymentStatus")
                ) || watch("serviceName") === "Venta De Baterias"
              }
            />
          )}

          {watch("serviceName") === "Grua" && (
            <>
              <Input
                bootstrap={"col-3"}
                label={"(Maniobra) USD*"}
                type={"number"}
                name={"amountHandling"}
                register={register}
                placeholder={""}
                errors={errors?.amountHandling?.message}
                min={"0"}
                onChange={(e) => {
                  onChange?.handleAddIva(null, [
                    {
                      name: 'pvp',
                      valueToSum: watch("pvp"),
                    },
                    {
                      name: 'amountExcess',
                      valueToSum: watch("amountExcess"),
                    },
                    {
                      name: 'amountHandling',
                      valueToSum: e?.target?.value,
                    },
                  ], true)
                  onChange?.restorePaymentMethods()
                  onChange?.evaluatePaymentOtp({
                    amountHandling: e?.target?.value,
                  })
                }}
                disabled={
                  [PaymentStatus?.N_A, PaymentStatus?.COURTESY].includes(
                    watch("paymentStatus")
                  )
                }
              />
              <Input
                bootstrap={"col-3"}
                label={"(Excedente) USD*"}
                type={"number"}
                name={"amountExcess"}
                register={register}
                placeholder={""}
                errors={errors?.amountExcess?.message}
                min={"0"}
                onChange={(e) => {
                  onChange?.handleAddIva(null, [
                    {
                      name: 'pvp',
                      valueToSum: watch("pvp"),
                    },
                    {
                      name: 'amountExcess',
                      valueToSum: e?.target?.value,
                    },
                    {
                      name: 'amountHandling',
                      valueToSum: watch("amountHandling"),
                    },
                  ], true)
                  onChange?.restorePaymentMethods()
                  onChange?.evaluatePaymentOtp({
                    amountExcess: e?.target?.value,
                  })
                }}
                disabled={
                  [PaymentStatus?.N_A, PaymentStatus?.COURTESY].includes(
                    watch("paymentStatus")
                  )
                }
              />
            </>
          )}
          <h6>
            {watch("accumulatedAmount") > 0 &&
              `El cliente tiene un pago acumulado de ${watch(
                "accumulatedAmount"
              )}$`}
            <br />
            <br />
            <span style={{ color: "red" }}>
              {watch("paymentDifference") > 0 &&
                `Debe pagar una diferencia de ${watch("paymentDifference")}$`}
            </span>
          </h6>

          {watch("isLocksmith") && (
            <LocksmithInvoiceSection
              register={register}
              errors={errors}
              watch={watch}
              setValue={setValue}
            />
          )}

          {
            !watch("isLocksmith") && watch("pvp") > 0 && (
              <Input
                bootstrap={"col-12"}
                subLabel="Agregar IVA"
                type={"checkbox"}
                name={"addIva"}
                placeholder={""}
                register={register}
                errors={errors?.addIva?.message}
                onChange={(e) => onChange?.handleAddIva(e, [
                  {
                    name: 'pvp',
                    valueToSum: watch("pvp"),
                  },
                  {
                    name: 'amountExcess',
                    valueToSum: watch("amountExcess"),
                  },
                  {
                    name: 'amountHandling',
                    valueToSum: watch("amountHandling"),
                  },
                ])}
              />
            )
          }

          {
            !watch("isLocksmith") && watch("addIva") && (
              <div className="col-12 row">
                <Input
                  bootstrap={"col-6"}
                  label={"% IVA"}
                  type={"number"}
                  name={"ivaPercentage"}
                  register={register}
                  placeholder={""}
                  errors={errors?.ivaPercentage?.message}
                  min={"0"}
                  disabled
                  defaultValue={16}
                />
                <Input
                  bootstrap={"col-6"}
                  label={"Monto IVA USD"}
                  type={"number"}
                  name={"ivaAmount"}
                  register={register}
                  placeholder={""}
                  errors={errors?.ivaAmount?.message}
                  min={"0"}
                  disabled
                />
              </div>
            )
          }

          {(watch("paymentDifference") > 0 ||
            [PaymentStatus?.CUENTA_POR_COBRAR].includes(
              watch("paymentStatus")
            )) && (
              <div style={{ width: "100%" }} className="row">
                {watch("paymentMethods") > 0 && (
                  <Input
                    bootstrap={"col-3"}
                    label={"Fecha de Pago"}
                    type={"date"}
                    name={"paymentDate"}
                    register={register}
                    control={control}
                    placeholder={""}
                    errors={errors?.paymentDate?.message}
                    onChange={onChange?.getDollarRateByPaymentDate}
                  />
                )}
                {(watch("pvp") > 0 ||
                  watch("amountHandling") > 0 ||
                  watch("amountExcess") > 0) &&
                  ![PaymentStatus?.N_A].includes(watch("paymentStatus")) && (
                    <>
                      <Input
                        bootstrap={"col-3"}
                        label={"Cantidad de Métodos de Pago"}
                        type={"number"}
                        name={"paymentMethods"}
                        register={register}
                        placeholder={""}
                        errors={errors?.paymentMethods?.message}
                        options={options?.paymentMethods}
                        onChange={onChange?.validateMaxPaymentMethods}
                        min={"0"}
                        max={"2"}
                      />
                      <div className="col-12"></div>
                    </>
                  )}
                {watch("paymentMethods") > 0 &&
                  (watch("pvp") > 0 ||
                    watch("amountHandling") > 0 ||
                    watch("amountExcess") > 0) &&
                  ![PaymentStatus?.N_A].includes(watch("paymentStatus")) && (
                    <>
                      {watch("paymentMethods") > 0 &&
                        (watch("pvp") > 0 ||
                          watch("amountHandling") > 0 ||
                          watch("amountExcess") > 0) &&
                        ![PaymentStatus?.N_A].includes(
                          watch("paymentStatus")
                        ) && (
                          <>
                            {paymentMethods(
                              filterOption(
                                options?.paymentMethods,
                                metodosDePago?.CASH_USD
                              )
                            ).map((p, index) => (
                              <PaymentSection
                                key={p?.label || `skipApi-${p?.index}-${index}`}
                                payment={p}
                                watch={watch}
                                register={register}
                                errors={errors}
                                options={options}
                                index={p?.index}
                                returnAccountData={returnAccountData}
                                fileUploaded={fileUploaded}
                                setFileUploaded={setFileUploaded}
                                onChange={onChange}
                                setValue={setValue}
                                showErrorAPI={showErrorAPI}
                              />
                            ))}
                          </>
                        )}
                    </>
                  )}
                <CashBackComponent
                  register={register}
                  errors={errors}
                  watch={watch}
                  options={{
                    paymemtMethodOptions: options?.paymentMethods,
                    filteredMethods: options?.filteredMethods,
                  }}
                  onChange={{
                    handleCashbackBs: onChange?.handleCashbackBs,
                    handleCashbackMethodsQuantity:
                      onChange?.handleCashbackMethodsQuantity,
                  }}
                  handleDrop={handleDrop}
                  cashBackImage={cashBackImage}
                  removeFile={removeFile}
                  errorsDropzone={errorsDropzone}
                />
              </div>
            )}
        </div>
      </div>

      <EditServicePaymentTable
        handleEditPayment={handleEditPayment}
        header={editServicePaymentTableHeader}
        data={modal?.selected?.payments}
      // cancelService={cancelService}
      />

      <div className="buttons-center-container">
        <AltButton action={() => cancel()} label={"Cancelar"} />
        {![1]?.includes(OTP?.optStatus) && (
          <ActionButton action={action} label={"Guardar"} />
        )}
      </div>
    </>
  );
};
export const EditPaymentForm = (props) => {
  const {
    register,
    options,
    errors,
    cancel,
    action,
    control,
    onChange,
    paymentDate,
    watch,
  } = props;

  return (
    <>
      <div style={{ margin: "0px" }} className="buttons-container">
        <h2 style={{ margin: "0px" }}>Editar pago </h2>
      </div>
      <p style={{ margin: "0px" }}>(*) Informacion de pago</p>
      <div style={{ maxWidth: "900px" }} className="form-container">
        <div className="row">
          <Input
            bootstrap={"col-3"}
            label={"Monto *"}
            type={"number"}
            name={"amount"}
            register={register}
            placeholder={""}
            // onChange={onChange?.handlePriceChange}
            errors={errors?.amount?.message}
            min={"0"}
            disabled={true}
          />
          <Input
            bootstrap={"col-3"}
            label={"Monto Bs *"}
            type={"number"}
            name={"amountBsS"}
            register={register}
            placeholder={""}
            errors={errors?.amountBsS?.message}
            disabled={true}
          />
          <Input
            bootstrap={"col-3"}
            label={"Metodo *"}
            type={"select"}
            options={options?.paymentMethods}
            name={"method"}
            register={register}
            placeholder={""}
            errors={errors?.method?.message}
          />
          <Input
            bootstrap={"col-3"}
            label={
              isZelleOrPaypal(options?.paymentMethods, watch("method"))
                ? "Titular *"
                : "Referencia *"
            }
            type={"text"}
            // options={options?.brandOptions}
            name={"reference"}
            register={register}
            placeholder={""}
            errors={errors?.reference?.message}
          />
          {[
            paymentMethods?.CASH_USD,
            paymentMethods?.CASH_BS,
            paymentMethods?.CASH_EUR,
          ].includes(
            filterOptionById(options?.paymentMethods, watch(`method`)).name
          ) && (
              <Input
                bootstrap={"col-6"}
                label={"Caja de venta"}
                type={"select"}
                name={`cashReceiver`}
                register={register}
                placeholder={""}
                options={options.cashReceiverOptions}
                errors={errors?.cashReceiver?.message}
                disabled={false}
              />
            )}
          <FilterDatePicker
            bootstrap={"col-3"}
            label={"Fecha de Pago *"}
            type={"date"}
            name={"date"}
            placeholder={""}
            control={control}
            value={paymentDate}
            onChange={onChange?.getDollarRateByDate}
          />
        </div>
      </div>

      <div className="buttons-center-container">
        <AltButton action={() => cancel()} label={"Cancelar"} />
        <ActionButton action={action} label={"Guardar"} />
      </div>
    </>
  );
};

export const EditCashbackForm = (props) => {
  const {
    register,
    options,
    errors,
    cancel,
    action,
    control,
    fileUploaded,
    handleDrop,
    removeFile,
    errorsDropzone,
  } = props;

  return (
    <>
      <div style={{ margin: "0px" }} className="buttons-container">
        <h2 style={{ margin: "0px" }}>Editar Vuelto</h2>
      </div>
      <p style={{ margin: "0px" }}>(*) Informacion de pago</p>
      <form style={{ maxWidth: "900px" }} className="form-container">
        <div className="row">
          <Input
            bootstrap={"col-3"}
            label={"Metodo *"}
            type={"select"}
            name={"method"}
            register={register}
            placeholder={""}
            options={options?.paymentMethods}
            errors={errors?.method?.message}
          />
          <Input
            bootstrap={"col-3"}
            label={"Monto USD *"}
            type={"number"}
            name={"amount"}
            register={register}
            placeholder={""}
            errors={errors?.amount?.message}
            min={"0"}
          />
          <Input
            bootstrap={"col-3"}
            label={"Monto Bs*"}
            type={"number"}
            name={"amountBs"}
            register={register}
            placeholder={""}
            errors={errors?.amountBs?.message}
            min={"0"}
          />
          <Input
            bootstrap={"col-3"}
            label={"Fecha *"}
            type={"date"}
            name={"date"}
            register={register}
            control={control}
            placeholder={""}
            errors={errors?.date?.message}
          />
          <Input
            bootstrap={"col-3"}
            label={"Referencia *"}
            type={"text"}
            name={"ref"}
            register={register}
            placeholder={""}
            errors={errors?.ref?.message}
          />
          <FileDropzone
            handleDrop={handleDrop}
            index={0}
            file={fileUploaded}
            removeFile={removeFile}
            error={errorsDropzone?.[`error${0}`]}
          />
        </div>
      </form>
      <div className="buttons-center-container">
        <AltButton action={() => cancel()} label={"Cancelar"} />
        <ActionButton action={action} label={"Guardar"} />
      </div>
    </>
  );
};

export const CreateTowForm = (props) => {
  const {
    register,
    options,
    errors,
    cancel,
    action,
    watch,
    onChange,
    fileUploaded,
    setFileUploaded,
    selectedProvider,
    bsDisabled,
    handleDrop,
    cashBackImage,
    removeFile,
    errorsDropzone,
    OTP,
    showOtpByScale,
    setValue,
    showErrorAPI,
  } = props;
  const validateIfcanShow = () => {
    if (
      parseFloat(watch("pvp")) >= 0 ||
      parseFloat(watch("amountHandling")) >= 0 ||
      parseFloat(watch("amountExcess")) >= 0
    ) {
      return true;
    } else return false;
  };


  const paymentMethods = (metodo) => {
    let array = [];
    for (let i = 0; i < parseInt(watch("paymentMethods")); i++) {
      array.push({
        name: "method" + i,
        label: `Metodo ${i + 1} *`,
        type: "select",
        bootstrap: "col-3",
        errors: errors?.[`method` + i]?.message,
        index: i,
      });
      array.push({
        dropzone: "a",
        label: `Comprobante ${i + 1} *`,
        index: i,
      });

      let method = filterOptionById(
        options?.paymentMethods,
        watch("method" + i)
      );
      if ([metodosDePago.ZELLE, metodosDePago.PAYPAL].includes(method?.name)) {
        array.push({
          name: "accHolder" + i,
          label: `Titular ${i + 1} *`,
          type: "text",
          bootstrap: "col-3",
          errors: errors?.[`accHolder` + i]?.message,
        });
      }

      if (metodo._id === watch("method0") && i === 0) {
        array.push({
          name: "paid",
          label: `Monto Ingresado *`,
          type: "number",
          bootstrap: "col-3",
          errors: errors?.[`paid`]?.message,
        });
      }

      array.push({
        name: "amount" + i,
        label: `Monto ${i + 1} (USD) *`,
        type: "number",
        bootstrap: "col-3",
        errors: errors?.[`amount` + i]?.message,
      });
      array.push({
        name: "amountBsS" + i,
        label: `Monto ${i + 1} (Bs)*`,
        type: "number",
        bootstrap: "col-3",
        errors: errors?.[`amountBsS` + i]?.message,
        disabled: bsDisabled,
      });
      if (
        [
          metodosDePago?.CASH_USD,
          metodosDePago?.CASH_BS,
          metodosDePago?.CASH_EUR,
        ].includes(
          filterOptionById(options?.paymentMethods, watch(`method${i}`)).name
        )
      ) {
        array.push({
          name: "cashReceiver" + i,
          label: `Caja de venta ${i + 1} *`,
          type: "select",
          bootstrap: "col-3",
          errors: errors?.[`cashReceiver` + i]?.message,
          options: options.cashReceiverOptions,
        });
      }
      array.push({
        name: "reference" + i,
        label: `Referencia ${i + 1} *`,
        type: "text",
        bootstrap: "col-3",
        errors: errors?.[`reference` + i]?.message,
        disabled: [metodosDePago.ZELLE, metodosDePago.PAYPAL].includes(
          filterOptionById(options.filteredMethods, watch("method" + i))?.name
        ),
      });
      array.push({
        skipApiValidationError: true,
        index: i,
      });
      array.push({
        // name: 'paymentMethod' + i,
        // label: `Comprobante ${i + 1} *`,
        // type: 'text',
        bootstrap: "col-12",
        // errors: errors?.[`paymentMethod` + i]?.message,
      });
    }
    return array;
  };

  const returnAccountData = (paymentMethods, id) => {
    let [account] = paymentMethods.filter((a) => a._id === id);

    let showInfo = (text, value) => {
      if (value) {
        return text + value + "\n";
      } else return "";
    };

    let data = "";
    data =
      showInfo(``, capitalize(account?.name)) +
      showInfo(`Cuenta: `, account?.details?.account) +
      showInfo(`Banco: `, account?.details?.bank) +
      showInfo(`Numero de Cuenta: `, account?.details?.accountNumber) +
      showInfo(`Numero de Telefono: `, account?.details?.phone) +
      showInfo(`Cedula: `, account?.details?.rif);
    return data;
  };

  const sumExcess = () => {
    let pvp = parseFloat(watch("pvp")) || 0;
    let amountExcess = parseFloat(watch("amountExcess")) || 0;
    let amountHandling = parseFloat(watch("amountHandling")) || 0;
    let ivaAmount = parseFloat(watch("ivaAmount")) || 0;
    return pvp + amountExcess + amountHandling + ivaAmount;
  };

  const validateIfCanPay = (action) => {
    if (
      [
        PaymentStatus?.N_A,
        PaymentStatus?.COURTESY,
        PaymentStatus?.CUENTA_POR_COBRAR,
      ].includes(watch("paymentStatus"))
    ) {
      return <ActionButton action={action} label={"Guardar"} />;
    }

    if (
      ![
        PaymentStatus?.N_A,
        PaymentStatus?.COURTESY,
        PaymentStatus?.CUENTA_POR_COBRAR,
      ].includes(watch("paymentStatus")) &&
      validateIfcanShow() &&
      watch("reference0")
    ) {
      return <ActionButton action={action} label={"Guardar"} />;
    } else return null;
  };

  return (
    <>
      <div style={{ margin: "0px" }} className="buttons-container">
        <h2 style={{ margin: "0px" }}>Información Adicional</h2>
      </div>
      <p style={{ marginTop: "12px" }}>
        <b>Proveedor: </b> {selectedProvider?.contactName} &nbsp;&nbsp;&nbsp;
        <b>Contacto: </b>
        {selectedProvider?.phonePrefix}-{selectedProvider?.phoneNumber}
      </p>
      <p style={{ margin: "0px" }}>(*) Campos obligatorios</p>
      {/* <form style={{ maxWidth: "900px" }} className="form-container"> */}
      <div className="row">
        <Input
          bootstrap={"col-3"}
          label={"Tipo de Grua *"}
          type={"text"}
          name={"isInternal"}
          register={register}
          placeholder={""}
          errors={errors?.isInternal?.message}
          disabled={true}
        />
        <Input
          bootstrap={"col-3"}
          label={"Teléfono del Cliente *"}
          type={"text"}
          name={"contact"}
          register={register}
          placeholder={""}
          errors={errors?.contact?.message}
          disabled={true}
        />
        <Input
          bootstrap={"col-3"}
          label={"Año del Vehículo *"}
          type={"text"}
          name={"vehicleYear"}
          register={register}
          placeholder={""}
          errors={errors?.vehicleYear?.message}
          disabled={true}
        />
        <Input
          bootstrap={"col-3"}
          label={"Marca del Vehiculo *"}
          type={"text"}
          options={options?.brandOptions}
          name={"vehicleBrand"}
          register={register}
          placeholder={""}
          errors={errors?.vehicleBrand?.message}
          disabled={true}
        />{" "}
        <Input
          bootstrap={"col-3"}
          label={"Modelo del Vehiculo *"}
          type={"text"}
          options={options?.brandOptions}
          name={"vehicleModel"}
          register={register}
          placeholder={""}
          errors={errors?.vehicleModel?.message}
          disabled={true}
        />{" "}
        <Input
          bootstrap={"col-3"}
          label={"Placa del Vehículo *"}
          type={"text"}
          options={options?.brandOptions}
          name={"vehiclePlate"}
          register={register}
          placeholder={""}
          errors={errors?.vehiclePlate?.message}
          disabled={true}
        />
        <Input
          bootstrap={"col-3"}
          label={"Color del Vehículo *"}
          type={"text"}
          options={options?.brandOptions}
          name={"vehicleColor"}
          register={register}
          placeholder={""}
          errors={errors?.vehicleColor?.message}
          disabled={true}
        />
        {watch("isInternal") === userType?.EXTERNO && (
          <Input
            bootstrap={"col-3"}
            label={"Motivo de Selección de Grúa externa *"}
            type={"select"}
            name={"externalTowReason"}
            options={externalTowReasonsOptions}
            register={register}
            placeholder={""}
            errors={errors?.externalTowReason?.message}
          />
        )}
        <Input
          bootstrap={"col-3"}
          label={"Estatus de Pago *"}
          type={"select"}
          options={
            watch("amountExcess") > 0
              ? options?.PaymentStatusOptions.filter(
                (b) => b?.name !== PaymentStatus?.N_A
              )
              : options?.PaymentStatusOptions
          }
          name={"paymentStatus"}
          register={register}
          placeholder={""}
          onChange={onChange?.changePaymentStatus}
          errors={errors?.paymentStatus?.message}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p
            style={{
              fontSize: "1.1rem",
              marginTop: "3.3vh",
              marginRight: "1vw",
            }}
          >
            ¿Se está realizando una excepción con el cliente en este servicio?
          </p>

          <Input
            bootstrap={"col-4"}
            type={"select"}
            options={options?.towExceptionOptions}
            name={"exceptionReason"}
            register={register}
            placeholder={""}
            onChange={onChange?.exceptionReason}
            errors={errors?.exceptionReason?.message}
          />
        </div>
        {validateCourtesy(watch("paymentStatus"), PaymentStatus?.COURTESY) && (
          <>
            <Input
              bootstrap={"col-3"}
              label={"Autorizado por *"}
              type={"select"}
              options={options?.authorizedByOptions}
              name={"authorizedBy"}
              register={register}
              placeholder={""}
              errors={errors?.authorizedBy?.message}
            />
            <div className="col-9"></div>
          </>
        )}
        <>
          <Input
            bootstrap={"col-6"}
            label={"Costo del servicio USD *"}
            type={"number"}
            name={"price"}
            register={register}
            onChange={onChange?.handlePriceChange}
            placeholder={""}
            errors={errors?.price?.message}
            min={"0"}
          />
          {(showOtpByScale) && (
            <>
              {![0]?.includes(OTP?.optStatus) && (
                <>
                  <Input
                    bootstrap={"col-3"}
                    label={"Aprobado por *"}
                    type={"select"}
                    options={options?.authorizedByOptions}
                    name={"approvedBy"}
                    register={register}
                    placeholder={""}
                    errors={errors?.approvedBy?.message}
                    disabled={[2]?.includes(OTP?.optStatus)}
                  />
                  <Input
                    bootstrap={"col-3"}
                    label={"Código *"}
                    type={"text"}
                    name={"code"}
                    register={register}
                    placeholder={""}
                    errors={errors?.code?.message}
                    disabled={[2]?.includes(OTP?.optStatus)}
                  />
                </>
              )}

              {[1]?.includes(OTP?.optStatus) && (
                <div className="col-12">
                  <div className="row">
                    <div className="col-6" style={{ textAlign: "center" }}>
                      {/* <p>Por favor ingrese el código de autorización para poder gestionar el servicio con el costo marcado</p> */}
                      <p>
                        Solicitar el código de autorización para poder gestionar
                        el servicio con el costo marcado
                      </p>
                    </div>
                    <div className="col-6" style={{ textAlign: "center" }}>
                      <div
                        style={{ marginTop: "18px" }}
                        className="buttons-container"
                      >
                        {!watch("code") ? (
                          <ActionButton
                            label="Solicitar código de autorización"
                            action={() => OTP?.requestOTP()}
                            disabled={OTP?.blockedOTP}
                          />
                        ) : (
                          <ActionButton
                            label="Validar código de autorización"
                            action={() => OTP?.validateOTP()}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          <Input
            bootstrap={"col-6"}
            label={"Pago cliente (Servicio) USD*"}
            type={"number"}
            name={"pvp"}
            register={register}
            placeholder={""}
            errors={errors?.pvp?.message}
            min={"0"}
            onChange={() => {
              onChange?.handleAddIva(null, [
                {
                  name: 'pvp',
                  valueToSum: watch("pvp"),
                },
                {
                  name: 'amountExcess',
                  valueToSum: watch("amountExcess"),
                },
                {
                  name: 'amountHandling',
                  valueToSum: watch("amountHandling"),
                },
              ], true);
              onChange?.restorePaymentMethods();
            }}
            disabled={(() => {
              if (
                [PaymentStatus?.N_A, PaymentStatus?.COURTESY].includes(
                  watch("paymentStatus")
                )
              ) {
                return true;
              }
              if (showOtpByScale) {
                return [1]?.includes(OTP?.optStatus);
              } else {
                return false;
              }
            })()}
          />
          <Input
            bootstrap={"col-6"}
            label={"(Maniobra) USD*"}
            type={"number"}
            name={"amountHandling"}
            register={register}
            placeholder={""}
            errors={errors?.amountHandling?.message}
            min={"0"}
            onChange={() => {
              onChange?.handleAddIva(null, [
                {
                  name: 'pvp',
                  valueToSum: watch("pvp"),
                },
                {
                  name: 'amountExcess',
                  valueToSum: watch("amountExcess"),
                },
                {
                  name: 'amountHandling',
                  valueToSum: watch("amountHandling"),
                },
              ], true);
              onChange?.restorePaymentMethods();
            }}
            disabled={(() => {
              if (
                [PaymentStatus?.N_A, PaymentStatus?.COURTESY].includes(
                  watch("paymentStatus")
                )
              ) {
                return true;
              }
              if (showOtpByScale) {
                if ([1]?.includes(OTP?.optStatus)) return true;
              } else {
                return false;
              }
            })()}
          />
          <Input
            bootstrap={"col-6"}
            label={"(Excedente) USD*"}
            type={"number"}
            name={"amountExcess"}
            register={register}
            placeholder={""}
            errors={errors?.amountExcess?.message}
            min={"0"}
            onChange={() => {
              onChange?.handleAddIva(null, [
                {
                  name: 'pvp',
                  valueToSum: watch("pvp"),
                },
                {
                  name: 'amountExcess',
                  valueToSum: watch("amountExcess"),
                },
                {
                  name: 'amountHandling',
                  valueToSum: watch("amountHandling"),
                },
              ], true);
              onChange?.restorePaymentMethods();
            }}
            disabled={(() => {
              if (
                ![operationsRoles.operationsAdmin].includes(
                  authService.getUserType()
                )
              ) {
                return true;
              }
              if (
                [PaymentStatus?.N_A, PaymentStatus?.COURTESY].includes(
                  watch("paymentStatus")
                )
              ) {
                return true;
              }
              if (showOtpByScale) {
                if ([1]?.includes(OTP?.optStatus)) return true;
              } else {
                return false;
              }
            })()}
          />

          <Input
            bootstrap={"col-12"}
            subLabel="Agregar IVA"
            type={"checkbox"}
            name={"addIva"}
            placeholder={""}
            register={register}
            errors={errors?.addIva?.message}
            onChange={(e) => onChange?.handleAddIva(e, [
              {
                name: 'pvp',
                valueToSum: watch("pvp"),
              },
              {
                name: 'amountExcess',
                valueToSum: watch("amountExcess"),
              },
              {
                name: 'amountHandling',
                valueToSum: watch("amountHandling"),
              },
            ])}
          />

          {
            watch("addIva") && (
              <div className="col-12 row">
                <Input
                  bootstrap={"col-6"}
                  label={"% IVA"}
                  type={"number"}
                  name={"ivaPercentage"}
                  register={register}
                  placeholder={""}
                  errors={errors?.ivaPercentage?.message}
                  min={"0"}
                  disabled
                  defaultValue={16}
                />
                <Input
                  bootstrap={"col-6"}
                  label={"Monto IVA USD"}
                  type={"number"}
                  name={"ivaAmount"}
                  register={register}
                  placeholder={""}
                  errors={errors?.ivaAmount?.message}
                  min={"0"}
                  disabled
                />
              </div>
            )
          }

          {validateIfcanShow() && <h4>Monto Total: {sumExcess()} $</h4>}
        </>

        {(watch("pvp") > 0 ||
          watch("amountHandling") > 0 ||
          watch("amountExcess") > 0) &&
          ![
            PaymentStatus?.N_A,
            PaymentStatus?.COURTESY,
            PaymentStatus?.CUENTA_POR_COBRAR,
          ].includes(watch("paymentStatus")) && (
            <>
              <Input
                bootstrap={"col-4"}
                label={"Cantidad de Métodos de Pago"}
                type={"number"}
                name={"paymentMethods"}
                register={register}
                placeholder={""}
                errors={errors?.paymentMethods?.message}
                options={options?.paymentMethods}
                onChange={onChange?.validateMaxPaymentMethods}
                min={"1"}
                max={"5"}
              />
              <div className="col-8"></div>
            </>
          )}
        {watch("paymentMethods") > 0 &&
          (watch("pvp") > 0 ||
            watch("amountHandling") > 0 ||
            watch("amountExcess") > 0) &&
          ![
            PaymentStatus?.N_A,
            PaymentStatus?.COURTESY,
            PaymentStatus?.CUENTA_POR_COBRAR,
          ].includes(watch("paymentStatus")) && (
            <>
              {paymentMethods(
                filterOption(options?.paymentMethods, metodosDePago?.CASH_USD)
              ).map((p, index) => (
                <PaymentSection
                  key={p?.label || `skipApi-${p?.index}-${index}`}
                  payment={p}
                  watch={watch}
                  options={options}
                  register={register}
                  errors={errors}
                  index={p.index}
                  returnAccountData={returnAccountData}
                  fileUploaded={fileUploaded}
                  setFileUploaded={setFileUploaded}
                  onChange={onChange}
                  setValue={setValue}
                  showErrorAPI={showErrorAPI}
                />
              ))}
            </>
          )}
        <CashBackComponent
          register={register}
          errors={errors}
          watch={watch}
          options={{
            paymemtMethodOptions: options?.paymentMethods,
            filteredMethods: options?.filteredMethods,
          }}
          onChange={{
            handleCashbackBs: onChange?.handleCashbackBs,
            handleCashbackMethodsQuantity:
              onChange?.handleCashbackMethodsQuantity,
          }}
          handleDrop={handleDrop}
          cashBackImage={cashBackImage}
          removeFile={removeFile}
          errorsDropzone={errorsDropzone}
        />
      </div>
      <div className="buttons-center-container">
        <AltButton action={() => cancel()} label={"Cancelar"} />
        {validateIfCanPay(action)}
      </div>
    </>
  );
};

export const CreateFleetMaintenanceForm = (props) => {
  const { register, options, errors, cancel, action, watch, control, title } =
    props;

  const [isNewProvider, setIsNewProvider] = useState(false);

  return (
    <>
      <div style={{ margin: "0px" }} className="buttons-container">
        <h2 style={{ margin: "0px" }}>{title}</h2>
      </div>
      <p style={{ margin: "0px" }}>(*) Campos obligatorios</p>
      <div className="row" style={{ width: "60%" }}>
        <Input
          bootstrap={"col-6"}
          label={"Tipo de Unidad *"}
          type={"select"}
          options={options?.unitTypeOptions}
          name={"type"}
          register={register}
          placeholder={""}
          errors={errors?.type?.message}
          control={control}
          disabled={true}
        />
        <Input
          bootstrap={"col-6"}
          label={"Registrado por *"}
          type={"select"}
          options={options?.adminOptions}
          name={"createdBy"}
          register={register}
          placeholder={""}
          errors={errors?.createdBy?.message}
          control={control}
        />
      </div>
      <div className="row" style={{ width: "60%" }}>
        <Input
          bootstrap={"col-6"}
          label={"Unidad *"}
          type={"select"}
          options={options?.unitOptions}
          name={"unit"}
          register={register}
          placeholder={""}
          errors={errors?.unit?.message}
          control={control}
          capitalizeOff={true}
        />
        <Input
          bootstrap={"col-6"}
          label={"Aprobado por *"}
          type={"select"}
          options={options?.adminOptions}
          name={"approvedBy"}
          register={register}
          placeholder={""}
          errors={errors?.approvedBy?.message}
          control={control}
        />
        <Input
          bootstrap={"col-6"}
          label={"Fecha de registro *"}
          type={"date"}
          name={"creationDate"}
          register={register}
          placeholder={""}
          errors={errors?.creationDate?.message}
          disabled={true}
          control={control}
        />
        <Input
          bootstrap={"col-6"}
          label={"Tipo de mantenimiento *"}
          type={"select"}
          options={options?.manteinanceTypeOptions}
          name={"maintenanceType"}
          register={register}
          placeholder={""}
          errors={errors?.maintenanceType?.message}
          control={control}
        />
      </div>
      <br />
      <div className="row" style={{ width: "60%" }}>
        <hr />
        <Input
          bootstrap={"col-6"}
          label={"Sistema *"}
          type={"select"}
          options={options?.systemOptions}
          name={"systemId"}
          register={register}
          placeholder={""}
          errors={errors?.systemId?.message}
          control={control}
        />
        <Input
          bootstrap={"col-6"}
          label={"Componente *"}
          type={"select"}
          options={options?.componentOptions}
          name={"componentId"}
          register={register}
          placeholder={""}
          errors={errors?.componentId?.message}
          disabled={!watch("systemId")}
          control={control}
        />
      </div>
      <div className="row" style={{ width: "60%" }}>
        <Input
          bootstrap={"col-6"}
          label={"Costo del servicio *"}
          type={"number"}
          name={"cost"}
          register={register}
          placeholder={""}
          errors={errors?.cost?.message}
          control={control}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "45%",
          }}
        >
          <Input
            bootstrap={"col-12"}
            label={"Proveedor *"}
            type={isNewProvider ? "text" : "select"}
            name={"provider"}
            options={options?.maintenanceProvidersOptions}
            register={register}
            placeholder={""}
            errors={errors?.provider?.message}
            control={control}
          />
          <img
            src={isNewProvider ? closeSquare : addSquare}
            alt="icon"
            srcSet=""
            style={{
              width: "44px",
              height: "44px",
              marginLeft: "2px",
              marginTop: "14px",
              cursor: "pointer",
            }}
            onClick={() => {
              setIsNewProvider(!isNewProvider);
            }}
          />
        </div>
      </div>
      <div className="row" style={{ width: "60%" }}>
        <Input
          bootstrap={"col-6"}
          label={"Fecha de entrada *"}
          type={"date-time"}
          name={"dateIn"}
          register={register}
          placeholder={""}
          errors={errors?.dateIn?.message}
          control={control}
        />
        <Input
          bootstrap={"col-6"}
          label={"Fecha de salida *"}
          type={"date-time"}
          name={"dateOut"}
          register={register}
          placeholder={""}
          errors={errors?.dateOut?.message}
          control={control}
        />
      </div>
      <div className="row" style={{ width: "60%" }}>
        <Input
          bootstrap={"col-6"}
          label={"Km unidad *"}
          type={"number"}
          name={"km"}
          register={register}
          placeholder={""}
          errors={errors?.km?.message}
          control={control}
        />
        <Input
          bootstrap={"col-6"}
          label={"Estatus de la unidad*"}
          type={"select"}
          options={options?.unitStatus}
          name={"unitStatus"}
          register={register}
          placeholder={""}
          errors={errors?.unitStatus?.message}
          control={control}
          disabled={!watch("dateOut")}
        />
      </div>
      <div className="row" style={{ width: "60%" }}>
        <Input
          bootstrap={"col-12"}
          label={"Comentario Adicional *"}
          type={"textarea"}
          name={"comment"}
          register={register}
          placeholder={""}
          errors={errors?.comment?.message}
          control={control}
        />
      </div>
      <br />
      <div className="buttons-center-container">
        <AltButton action={() => cancel()} label={"Cancelar"} />
        <ActionButton
          action={() => {
            action();
          }}
          label={"Guardar"}
        />
      </div>
    </>
  );
};

export const CreateFleetIncidenceForm = (props) => {
  const {
    register,
    options,
    errors,
    cancel,
    action,
    watch,
    control,
    title,
    onChange,
    setValue,
  } = props;
  return (
    <>
      <div style={{ margin: "0px" }} className="buttons-container">
        <h2 style={{ margin: "0px" }}>{title}</h2>
      </div>
      <p style={{ margin: "0px" }}>(*) Campos obligatorios</p>
      <div className="row" style={{ width: "60%" }}>
        <Input
          bootstrap={"col-6"}
          label={"Tipo de Unidad *"}
          type={"select"}
          options={options?.unitTypeOptions}
          name={"unitType"}
          register={register}
          placeholder={""}
          errors={errors?.unitType?.message}
          control={control}
          // disabled={true}
          onChange={(e) => {
            onChange?.unitType(e, setValue);
          }}
        />
        <Input
          bootstrap={"col-6"}
          label={"Registrado por *"}
          type={"select"}
          options={options?.adminOptions}
          name={"registeredBy"}
          register={register}
          placeholder={""}
          errors={errors?.registeredBy?.message}
          control={control}
        />
      </div>
      <div className="row" style={{ width: "60%" }}>
        <Input
          bootstrap={"col-6"}
          label={"Unidad *"}
          type={"select"}
          options={options?.unitOptions}
          name={"unit"}
          register={register}
          placeholder={""}
          errors={errors?.unit?.message}
          control={control}
          capitalizeOff={true}
        />
      </div>
      <div className="row" style={{ width: "60%" }}>
        <Input
          bootstrap={"col-6"}
          label={"Fecha de registro *"}
          type={"date"}
          name={"registrationDate"}
          register={register}
          placeholder={""}
          errors={errors?.registrationDate?.message}
          control={control}
          disabled={true}
        />
      </div>
      <br />
      <div className="row" style={{ width: "60%" }}>
        <hr />
        <Input
          bootstrap={"col-6"}
          label={"Fecha del siniestro *"}
          type={"date"}
          name={"accidentDate"}
          register={register}
          placeholder={""}
          errors={errors?.accidentDate?.message}
          control={control}
        />
        <Input
          bootstrap={"col-6"}
          label={"Chofer *"}
          type={"select"}
          name={"driver"}
          register={register}
          options={options.providersOptions}
          placeholder={""}
          errors={errors?.driver?.message}
          control={control}
        />
      </div>
      <div className="row" style={{ width: "60%" }}>
        <Input
          bootstrap={"col-6"}
          label={"Zona del siniestro *"}
          type={"text"}
          name={"accidentLocation"}
          register={register}
          placeholder={""}
          errors={errors?.accidentLocation?.message}
          control={control}
        />
        <Input
          bootstrap={"col-6"}
          label={"Estatus de la unidad*"}
          type={"select"}
          options={options?.unitStatus}
          name={"unitStatus"}
          register={register}
          placeholder={""}
          errors={errors?.unitStatus?.message}
          control={control}
        />
      </div>
      <div className="row" style={{ width: "60%" }}>
        <Input
          bootstrap={"col-12"}
          label={"Explicación detallada *"}
          type={"textarea"}
          name={"detail"}
          register={register}
          placeholder={""}
          errors={errors?.detail?.message}
          control={control}
        />
      </div>
      <br />
      <div className="buttons-center-container">
        <AltButton action={() => cancel()} label={"Cancelar"} />
        <ActionButton action={action} label={"Guardar"} />
      </div>
    </>
  );
};

export const ComplaintsForm = (props) => {
  const {
    register,
    options,
    errors,
    cancel,
    action,
    watch,
    control,
    title,
    onChange,
    setValue,
    getServicesByCode,
  } = props;
  return (
    <>
      <div style={{ margin: "0px" }} className="buttons-container">
        <h2 style={{ margin: "0px" }}>{title}</h2>
      </div>
      <p style={{ margin: "0px" }}>(*) Campos obligatorios</p>
      <div className="row" style={{ width: "60%" }}>
        <Input
          bootstrap={"col-6"}
          label={"Categoria *"}
          type={"select"}
          options={options?.serviceComplainOptions}
          name={"category"}
          register={register}
          placeholder={""}
          errors={errors?.category?.message}
          control={control}
        />
        <Input
          bootstrap={"col-6"}
          label={"Fecha de la queja *"}
          type={"date"}
          name={"complaintDate"}
          register={register}
          placeholder={""}
          errors={errors?.complaintDate?.message}
          control={control}
        // disabled={true}
        />
        <Input
          bootstrap={"col-6"}
          label={"Nombre del cliente *"}
          type={"text"}
          name={"clientName"}
          register={register}
          placeholder={""}
          errors={errors?.clientName?.message}
          control={control}
        />
        <SearchServiceInput
          label={"Código de Servicio *"}
          name="serviceId"
          register={register}
          setValue={setValue}
          errors={errors}
          getServicesByCode={getServicesByCode}
          control={control}
          watch={watch}
        />
        <Input
          bootstrap={"col-6"}
          label={"Teléfono de contacto *"}
          type={"text"}
          name={"clientPhone"}
          register={register}
          placeholder={""}
          errors={errors?.clientPhone?.message}
          control={control}
        />
        <Input
          bootstrap={"col-6"}
          label={"Placa *"}
          type={"text"}
          name={"plate"}
          register={register}
          placeholder={""}
          errors={errors?.plate?.message}
          control={control}
        />
        <Input
          bootstrap={"col-6"}
          label={"Red Social *"}
          type={"select"}
          options={options?.socialNetworkOptions}
          name={"socialMedia"}
          register={register}
          placeholder={""}
          errors={errors?.socialMedia?.message}
          control={control}
        />
        <Input
          bootstrap={"col-6"}
          label={"Tipificación de la queja *"}
          type={"select"}
          options={options?.classificationOptions}
          name={"classification"}
          register={register}
          placeholder={""}
          errors={errors?.classification?.message}
          control={control}
          capitalizeOff={true}
        />
        <Input
          bootstrap={"col-6"}
          label={"Colaborador responsable"}
          type={"select"}
          options={options?.LeadContributorOptions}
          name={"leadContributor"}
          register={register}
          placeholder={""}
          errors={errors?.leadContributor?.message}
          control={control}
          capitalizeOff={true}
          onChange={(e) => {
            setValue("contributorName", "");
          }}
        />
        <Input
          bootstrap={"col-6"}
          label={"Nombre del colaborador"}
          type={"select"}
          options={options?.leadContributorNameList}
          name={"contributorName"}
          register={register}
          placeholder={""}
          errors={errors?.contributorName?.message}
          control={control}
          capitalizeOff={true}
        />
        <Input
          bootstrap={"col-6"}
          label={"Segmentación *"}
          type={"select"}
          options={options?.SegmentationOptions}
          name={"segmentation"}
          register={register}
          placeholder={""}
          errors={errors?.segmentation?.message}
          control={control}
          capitalizeOff={true}
        />
        <Input
          bootstrap={"col-12"}
          label={"Detalle del Reporte *"}
          type={"textarea"}
          name={"details"}
          register={register}
          placeholder={""}
          errors={errors?.details?.message}
          control={control}
        // disabled={true}
        />
      </div>
      <br />
      <div className="row" style={{ width: "60%" }}>
        <hr />
        <Input
          bootstrap={"col-6"}
          label={"Estatus *"}
          type={"select"}
          name={"status"}
          register={register}
          options={options.statusOptions}
          placeholder={""}
          errors={errors?.status?.message}
          control={control}
          noBlankOption={true}
          onChange={onChange?.handleChangeStatus}
        />
      </div>
      {watch("status") === "Finalizado" && (
        <>
          <div className="row" style={{ width: "60%" }}>
            <Input
              bootstrap={"col-6"}
              label={"Solución *"}
              type={"select"}
              name={"solution"}
              register={register}
              options={options.solutionOptions}
              placeholder={""}
              errors={errors?.solution?.message}
              control={control}
            />
            <Input
              bootstrap={"col-6"}
              label={"Monto de la solución"}
              type={"number"}
              name={"solutionAmount"}
              register={register}
              placeholder={""}
              errors={errors?.solutionAmount?.message}
              control={control}
            />
            <Input
              bootstrap={"col-6"}
              label={"Satisfacción del cliente *"}
              type={"select"}
              name={"clientSatisfaction"}
              register={register}
              options={options.clientSatisfactionOptions}
              placeholder={""}
              errors={errors?.clientSatisfaction?.message}
              control={control}
            />
            <Input
              bootstrap={"col-6"}
              label={"Comentario de la solución *"}
              type={"textarea"}
              name={"solutionDetails"}
              register={register}
              placeholder={""}
              errors={errors?.solutionDetails?.message}
              control={control}
            />
          </div>
        </>
      )}

      <br />
      <div className="buttons-center-container">
        <AltButton action={() => cancel()} label={"Cancelar"} />
        <ActionButton action={action} label={"Guardar"} />
      </div>
    </>
  );
};

export const BatterySaleForm = (props) => {
  const { register, options, errors, title, onChange } = props;
  return (
    <>
      <div style={{ margin: "0px" }} className="buttons-container">
        <h2 style={{ margin: "0px" }}>{title}</h2>
      </div>
      <p style={{ margin: "0px" }}>(*) Campos obligatorios</p>
      <div className="row" style={{ width: "400px" }}>
        <Input
          bootstrap={"col-12"}
          label={"Modelo de Batería *"}
          type={"select"}
          name={"battery"}
          register={register}
          placeholder={""}
          onChange={onChange?.handleBatteryChange}
          options={options?.batteryOptions}
          errors={errors?.battery?.message}
          capitalizeOff={true}
        />
        <Input
          bootstrap={"col-12"}
          label={"Precio de la batería *"}
          type={"number"}
          name={"price"}
          register={register}
          placeholder={""}
          errors={errors?.price?.message}
          disabled={true}
        />
      </div>
    </>
  );
};
